const I24MXCoordinates = [
  // ID Miguel Hidalgo: V1-C-522
  [
    [-99.1636893646724, 19.456430230770593],
    [-99.16418524455338, 19.452045360405123],
    [-99.16424920523662, 19.450137983780962],
    [-99.16556266688355, 19.44391331364858],
    [-99.16653348683093, 19.442371423302575],
    [-99.1680182711263, 19.43888789216254],
    [-99.17761225759955, 19.42367599824877],
    [-99.17509954730622, 19.423104926950884],
    [-99.175299421631, 19.42273373177636],
    [-99.17555640290561, 19.42273373177636],
    [-99.17627024157832, 19.421620143554833],
    [-99.17635590200325, 19.420877752306467],
    [-99.17658433070227, 19.42033523538288],
    [-99.17715540110083, 19.420106806683805],
    [-99.17778357934867, 19.4193358610612],
    [-99.17784068629862, 19.418993219361653],
    [-99.18426523075578, 19.407885895118],
    [-99.1711020518182, 19.403488650980535],
    [-99.17027400014496, 19.400176440690245],
    [-99.17044532099476, 19.3998337989907],
    [-99.17078225289862, 19.39981666690568],
    [-99.17891429875584, 19.397441013292166],
    [-99.17950821193438, 19.397441013292166],
    [-99.18202092312708, 19.39698415589413],
    [-99.18261483720494, 19.396664356974554],
    [-99.18621258224482, 19.395750643977067],
    [-99.1892350030929, 19.395801200265225],
    [-99.19092737609748, 19.399766907416904],
    [-99.19225987369418, 19.401327833712628],
    [-99.19214565979433, 19.403802473005783],
    [-99.19766600877927, 19.403155259707546],
    [-99.20052136167146, 19.402165403810386],
    [-99.20170157526746, 19.401594333411822],
    [-99.20746177883797, 19.40098874163715],
    [-99.21029333836685, 19.400512850088035],
    [-99.21243485258634, 19.39984660084002],
    [-99.21364837797023, 19.399227941016704],
    [-99.21488569671749, 19.398728254305524],
    [-99.2163276508004, 19.39818097816965],
    [-99.2217528218352, 19.39644873012486],
    [-99.22396096232853, 19.395801516826566],
    [-99.22510310312566, 19.395611160027045],
    [-99.22592163817302, 19.395706338876494],
    [-99.22668306537116, 19.395801516826566],
    [-99.2275206345696, 19.395801516826566],
    [-99.23003334576225, 19.395268518327498],
    [-99.23104223760913, 19.39484973282896],
    [-99.23149909410785, 19.39486876787936],
    [-99.23250798595473, 19.394925874829312],
    [-99.23578212434552, 19.3936314491321],
    [-99.23623897994491, 19.393517235232252],
    [-99.23743822859132, 19.3936314491321],
    [-99.23783797814013, 19.39353627028271],
    [-99.23892301198737, 19.392812914084743],
    [-99.23907529778671, 19.39243219958638],
    [-99.23901819083682, 19.39153752343799],
    [-99.23899915488704, 19.39064284639028],
    [-99.23962733313488, 19.389139026145187],
    [-99.24016033163394, 19.38872024064665],
    [-99.24134054522995, 19.388111099247908],
    [-99.24206390142785, 19.38742581405012],
    [-99.2428824355759, 19.386968957551403],
    [-99.24349157787401, 19.386930885651907],
    [-99.24391036337255, 19.38708317235057],
    [-99.2450144331695, 19.387444849999895],
    [-99.2456426096187, 19.38740677899972],
    [-99.24619464496686, 19.3871783503007],
    [-99.24729871476382, 19.386264637303213],
    [-99.24761183801587, 19.386012579816736],
    [-99.24800698393511, 19.3869022251576],
    [-99.24832678285469, 19.387694109695474],
    [-99.24852475421397, 19.389947934849374],
    [-99.24849429687424, 19.39057230626696],
    [-99.2478699272553, 19.391851503743965],
    [-99.24697144157875, 19.392673845621516],
    [-99.24669732821911, 19.393633245078263],
    [-99.24684961401846, 19.39404441511772],
    [-99.24707804181816, 19.394272843816736],
    [-99.24780901167651, 19.39434898581709],
    [-99.24817449795466, 19.394135787136918],
    [-99.24864658267364, 19.393633245078263],
    [-99.2491643529525, 19.393404816379245],
    [-99.2500476086102, 19.393709387078616],
    [-99.25082426492787, 19.393678929738883],
    [-99.25132680788585, 19.393480959278918],
    [-99.25294103430127, 19.393572330398797],
    [-99.25358063303975, 19.394409901395875],
    [-99.2545704889369, 19.39524747059437],
    [-99.25484460319586, 19.39529315705363],
    [-99.25496643075616, 19.39504950013435],
    [-99.25484460319586, 19.394760156755865],
    [-99.2544029749173, 19.394364214936616],
    [-99.25426591823748, 19.39409010067766],
    [-99.25516440211544, 19.393587558619004],
    [-99.25592583021285, 19.393450501939185],
    [-99.25607811511287, 19.39329821613984],
    [-99.25656542895138, 19.392856587861274],
    [-99.2577989417677, 19.392734760300982],
    [-99.25842331228597, 19.392719532080775],
    [-99.2587278829854, 19.392414961381405],
    [-99.25903245368477, 19.392460646042025],
    [-99.25919235404388, 19.392659568884028],
    [-99.25969204075506, 19.39406345106744],
    [-99.25962065706761, 19.394372780979097],
    [-99.25831195283433, 19.39513420907656],
    [-99.25647976762713, 19.39646670667321],
    [-99.25569454616635, 19.39718054534592],
    [-99.25521865371786, 19.398774784328907],
    [-99.25524244887987, 19.39936964899016],
    [-99.25545659994208, 19.400392816675208],
    [-99.25521865371786, 19.401511164108967],
    [-99.2553852162547, 19.40208223540691],
    [-99.2554090114167, 19.40267710006816],
    [-99.25579486104397, 19.403560359323194],
    [-99.25527708986579, 19.40418472984146],
    [-99.25470221173765, 19.40469869418945],
    [-99.25416540640833, 19.404915699699814],
    [-99.25332022085149, 19.405132707008875],
    [-99.2528633652521, 19.405738041577422],
    [-99.2521780800543, 19.406069262786275],
    [-99.25170980216558, 19.406213934025857],
    [-99.25102451696785, 19.40638525577498],
    [-99.25049151756946, 19.406899219223646],
    [-99.25003466107074, 19.40726089687297],
    [-99.24934937677227, 19.40756546757234],
    [-99.2488734852231, 19.40806039597055],
    [-99.24837855682489, 19.408631467268435],
    [-99.24801687917562, 19.40876471711806],
    [-99.24757905772731, 19.408802788118237],
    [-99.24649402388008, 19.409145429817784],
    [-99.24495213263475, 19.409716501115668],
    [-99.24419070543667, 19.409944928915365],
    [-99.24371481298817, 19.410516000213306],
    [-99.24335313533891, 19.410725392063227],
    [-99.24306759968994, 19.4108015349629],
    [-99.24238231539152, 19.411296463361168],
    [-99.24194449394321, 19.411448749160513],
    [-99.24112595889585, 19.41181042680978],
    [-99.24053585344683, 19.412038854609477],
    [-99.239970434388, 19.41220166967139],
    [-99.23963730931433, 19.41220166967139],
    [-99.23885684616647, 19.41203034792227],
    [-99.23840950719296, 19.411992276922092],
    [-99.23766711504527, 19.412192152146133],
    [-99.23726736639583, 19.412372991420455],
    [-99.23701038422183, 19.412582383270433],
    [-99.23693424132216, 19.412668043695305],
    [-99.23645834887367, 19.41370548901716],
    [-99.23591583195002, 19.414552576640176],
    [-99.23559222530093, 19.41525689688831],
    [-99.23542090355181, 19.415409182687654],
    [-99.23508778027679, 19.415666164861648],
    [-99.23464044130327, 19.415970735561075],
    [-99.2345167089789, 19.416418073635214],
    [-99.23442153102877, 19.416589396283655],
    [-99.23409792437968, 19.416779753083176],
    [-99.23387901410518, 19.416760717133457],
    [-99.23372672830584, 19.416713127708704],
    [-99.23360299598147, 19.416589396283655],
    [-99.23340312075737, 19.417360341006997],
    [-99.23337456818172, 19.417798161555936],
    [-99.23321276395785, 19.417826715030913],
    [-99.23317469295768, 19.418197911104755],
    [-99.2330509606333, 19.418378750379077],
    [-99.233098550058, 19.418569107178598],
    [-99.23298433615815, 19.419025963677313],
    [-99.23299385368335, 19.419406677276413],
    [-99.23290819325848, 19.419435230751333],
    [-99.23270831893376, 19.419387642225956],
    [-99.23258458660933, 19.419387642225956],
    [-99.23242278328479, 19.41945426670111],
    [-99.2323751938601, 19.419616070025654],
    [-99.2323751938601, 19.419796909299976],
    [-99.23183267693645, 19.419977747674977],
    [-99.2317184630366, 19.420149069424042],
    [-99.23162328508653, 19.420339426223563],
    [-99.23157569476245, 19.420720139822663],
    [-99.23129016001286, 19.420824836197255],
    [-99.23103317783887, 19.42096760357208],
    [-99.23099510683869, 19.421215068220874],
    [-99.23093799988874, 19.421519638920245],
    [-99.23085233856455, 19.421719514144286],
    [-99.23042403644007, 19.42179565614464],
    [-99.23006235789148, 19.42184324556939],
    [-99.22973875124234, 19.42196697789376],
    [-99.22956743039254, 19.42215733379396],
    [-99.22933900169352, 19.422233476693634],
    [-99.22922478779367, 19.42245238786745],
    [-99.22900587661985, 19.422604672767477],
    [-99.22885359171983, 19.422728405091846],
    [-99.2286346823447, 19.423194779115818],
    [-99.22847287812078, 19.423318511440186],
    [-99.22847287812078, 19.423423207814835],
    [-99.22827300289674, 19.423508868239708],
    [-99.22789229019702, 19.42356597518966],
    [-99.22784469987295, 19.423632599664813],
    [-99.22788277177244, 19.423822957363654],
    [-99.22784469987295, 19.424051385163352],
    [-99.2277685578726, 19.42415608243732],
    [-99.22758771859827, 19.424241741962874],
    [-99.227226040949, 19.42427029633717],
    [-99.22707752330899, 19.424315497162524],
    [-99.22700712977519, 19.424336920812323],
    [-99.22671611725497, 19.424611730247193],
    [-99.22615191857614, 19.425578926826063],
    [-99.22603102001551, 19.4260826748756],
    [-99.22582951971651, 19.426546124304252],
    [-99.22538622229627, 19.42668717307464],
    [-99.22488247424673, 19.426868522264556],
    [-99.22447947544742, 19.427110322083763],
    [-99.22274658079004, 19.426344624005253],
    [-99.22264583064054, 19.426707323284404],
    [-99.2222025332203, 19.427029722144027],
    [-99.22254508228968, 19.42729167127368],
    [-99.22297986313015, 19.428607213951807],
    [-99.22332736026942, 19.429539969194252],
    [-99.22467811500297, 19.430118184706487],
    [-99.22646746999771, 19.430993826703798],
    [-99.22696239839593, 19.431602969001858],
    [-99.22620097029852, 19.434039537294836],
    [-99.22696239839593, 19.434648678693634],
    [-99.2274573249955, 19.435029393191996],
    [-99.22741925399532, 19.435448177791216],
    [-99.2272669690953, 19.435638534590737],
    [-99.2272669690953, 19.436780676287242],
    [-99.22814261019329, 19.43792281708437],
    [-99.22810453919311, 19.438265458783974],
    [-99.22433547330343, 19.440968526776146],
    [-99.22353597420579, 19.441806096873904],
    [-99.22037604881558, 19.44386195156784],
    [-99.21795851737164, 19.444280737066435],
    [-99.21967172856739, 19.444908915314215],
    [-99.22029990681523, 19.4462794839111],
    [-99.22012858596543, 19.452961011441573],
    [-99.21790141042175, 19.453246546191224],
    [-99.21670216177529, 19.4545029008882],
    [-99.21533159227914, 19.456444541682288],
    [-99.21413234363274, 19.45884303807577],
    [-99.21390391583299, 19.46044203627099],
    [-99.21259045328674, 19.462383676165757],
    [-99.21356127323412, 19.463011854413594],
    [-99.21213359678802, 19.46706645505293],
    [-99.21161963333935, 19.46706645505293],
    [-99.21156252638946, 19.468037275899633],
    [-99.21042038469295, 19.468722560198046],
    [-99.2089356012969, 19.470150236644145],
    [-99.20722238920189, 19.469636273195476],
    [-99.20687974660297, 19.471235271390697],
    [-99.20612181686829, 19.471705418969975],
    [-99.20357103467546, 19.47269527396776],
    [-99.20102025338196, 19.473418630165725],
    [-99.20052532498374, 19.473304416265876],
    [-99.19039833911205, 19.470410992373445],
    [-99.19069529615098, 19.464666020620427],
    [-99.18798461359899, 19.463828451421932],
    [-99.18853284211696, 19.4607979690511],
    [-99.18652267298296, 19.46032588433212],
    [-99.18524347460664, 19.459990856293018],
    [-99.1841774758098, 19.459869027833406],
    [-99.18399473357005, 19.459762427594],
    [-99.17907591232347, 19.459001000395915],
    [-99.17808605642631, 19.458696428797225],
    [-99.17755305702792, 19.458605057677346],
    [-99.17115706604574, 19.457584745339773],
    [-99.1696142233177, 19.457405809930208],
    [-99.1636893646724, 19.456430230770593]
  ],
  // ID Alvaro Obregón: V1-C-512
  [
    [-99.1892350030929, 19.395801200265225],
    [-99.18837659300533, 19.39378970103394],
    [-99.18921416400241, 19.390134849044102],
    [-99.19066087639828, 19.385680497956685],
    [-99.19168880329562, 19.383205858663473],
    [-99.19165073229544, 19.37768550877928],
    [-99.19210758789484, 19.373307300591478],
    [-99.19161266039595, 19.37193673109533],
    [-99.1917268742958, 19.368929093303052],
    [-99.19066087639828, 19.367101667308134],
    [-99.19108847974951, 19.36345277602487],
    [-99.18909068978348, 19.36297907342555],
    [-99.18798661998648, 19.363055216325222],
    [-99.18684447918935, 19.36214150332779],
    [-99.1853216238938, 19.361760788829372],
    [-99.18349419789888, 19.361836931729044],
    [-99.18288505560082, 19.362293788227817],
    [-99.18147641510444, 19.362941000626734],
    [-99.18029620240776, 19.362826786726885],
    [-99.17953477520967, 19.36316943022507],
    [-99.17926827461116, 19.36377857162381],
    [-99.17774542021493, 19.36518721301951],
    [-99.17508042412226, 19.36267450182686],
    [-99.17306264132782, 19.36035214833305],
    [-99.17176000032373, 19.359593648428188],
    [-99.17272147901303, 19.3571987790005],
    [-99.17509142193154, 19.35445764000815],
    [-99.17554827932958, 19.353829461760313],
    [-99.17720438357543, 19.35245889226411],
    [-99.17763268659917, 19.351802161440673],
    [-99.18003118299265, 19.34954643242196],
    [-99.18060225429059, 19.347062274704285],
    [-99.18180150203767, 19.3473478103532],
    [-99.18245823376043, 19.346605418205513],
    [-99.18294364373412, 19.346462650830745],
    [-99.18328628633299, 19.345577491308234],
    [-99.18337194675792, 19.344977867434693],
    [-99.18371458935678, 19.34420692181203],
    [-99.18385735673161, 19.343835725738188],
    [-99.18494239057884, 19.343378869239473],
    [-99.18651283529908, 19.34197974626835],
    [-99.18685547789795, 19.341237354120665],
    [-99.18771208304616, 19.34098037284599],
    [-99.18828315434405, 19.340323641123177],
    [-99.18931108124139, 19.339638355925445],
    [-99.19008202686399, 19.33866753597806],
    [-99.19125272113615, 19.336954323882992],
    [-99.19505034140008, 19.33626903958458],
    [-99.19742028431864, 19.33558375528611],
    [-99.198162675567, 19.33546954138626],
    [-99.19870519338991, 19.33504123836252],
    [-99.20004720941114, 19.33324236494326],
    [-99.19673500002023, 19.333784881866848],
    [-99.19622103567224, 19.333670667967],
    [-99.19647801784623, 19.33315670541765],
    [-99.19473625227619, 19.33013002987701],
    [-99.19490757402531, 19.32196371984986],
    [-99.1975916060677, 19.317652137036532],
    [-99.19970456681227, 19.314311374170643],
    [-99.20124645805754, 19.311484573854045],
    [-99.20058972633478, 19.31145602037907],
    [-99.20018997678596, 19.311256146054347],
    [-99.20512973784707, 19.306344937568838],
    [-99.20552948739589, 19.30668758016776],
    [-99.2057957721571, 19.30571642387389],
    [-99.20963433405723, 19.306395942618735],
    [-99.21360898496664, 19.307092649206425],
    [-99.21447701330351, 19.307286813735516],
    [-99.21567626105059, 19.30774367023423],
    [-99.21651002431815, 19.308246212292886],
    [-99.21735520897568, 19.308897233320693],
    [-99.21856587811277, 19.310313488376835],
    [-99.21984507738836, 19.3120838074218],
    [-99.21993644760892, 19.31226654876224],
    [-99.21994110609711, 19.312276899958988],
    [-99.22024482603786, 19.312951833960028],
    [-99.22061031141669, 19.31412823982646],
    [-99.22150308459965, 19.31909084366754],
    [-99.22128988502016, 19.320050242224966],
    [-99.22069597184156, 19.320887813222043],
    [-99.22040888935874, 19.321092504315686],
    [-99.21730000499122, 19.323309152395495],
    [-99.21527460763701, 19.32471017923143],
    [-99.2134471816421, 19.326019834048168],
    [-99.21242686930452, 19.327283804204228],
    [-99.2108278711093, 19.330451342355616],
    [-99.20970095763306, 19.33264425372937],
    [-99.20845221659647, 19.334532594403754],
    [-99.20762987561824, 19.335476763841655],
    [-99.20665763744, 19.33620824631356],
    [-99.20708022886942, 19.336550888912427],
    [-99.20864496199539, 19.33601408178447],
    [-99.20752566397817, 19.33789861472934],
    [-99.20833658356645, 19.337864350559357],
    [-99.20915892634332, 19.33756739441975],
    [-99.20998126822093, 19.336962059851203],
    [-99.21121478013794, 19.3362539318735],
    [-99.2114660507176, 19.33620824631356],
    [-99.21196859367564, 19.336288196043483],
    [-99.21232265676514, 19.33618540443291],
    [-99.2132477920519, 19.3365166247425],
    [-99.21354474909089, 19.33656231030244],
    [-99.21448130396897, 19.336482359673198],
    [-99.21491531768771, 19.33639098855332],
    [-99.2153379100165, 19.33611687519368],
    [-99.21541785974637, 19.335671440084923],
    [-99.21572623817531, 19.33540874721598],
    [-99.21602700204448, 19.335275498265673],
    [-99.21656951896807, 19.335275498265673],
    [-99.21683601866727, 19.33512321156701],
    [-99.21698830536599, 19.334875747817534],
    [-99.21713107184144, 19.33471394539231],
    [-99.21774973166475, 19.334647320017837],
    [-99.21854923076233, 19.33442840974334],
    [-99.21914885463588, 19.3340001067196],
    [-99.22129988817926, 19.33382878497048],
    [-99.22187095857782, 19.333733607020406],
    [-99.22237540360197, 19.333552767746085],
    [-99.22318442112407, 19.33317205414704],
    [-99.22423138397113, 19.332753268648503],
    [-99.22412668759654, 19.33251532332355],
    [-99.22418379544575, 19.332372555049403],
    [-99.22626820181603, 19.33157305595182],
    [-99.22715336223786, 19.331611127851318],
    [-99.22886847729836, 19.330775460718996],
    [-99.22927964823714, 19.330518479444322],
    [-99.22968510758159, 19.330358579085214],
    [-99.23008485802973, 19.33032431491523],
    [-99.23120986674195, 19.32983319424659],
    [-99.23151824517083, 19.329302098712958],
    [-99.23188372965035, 19.329027985353264],
    [-99.2321292913337, 19.328496888920313],
    [-99.2334598850656, 19.327246244019022],
    [-99.23408806331344, 19.32680651960527],
    [-99.23472480670443, 19.326491478998605],
    [-99.2359859206137, 19.325882336700545],
    [-99.23638091184955, 19.32544451705087],
    [-99.23648084901191, 19.325201811614363],
    [-99.23688059856073, 19.324892481702705],
    [-99.23733745505945, 19.32469736569095],
    [-99.23819406110698, 19.32454032067932],
    [-99.23868423029296, 19.32454032067932],
    [-99.23880796171801, 19.324468937891197],
    [-99.23922674721655, 19.324683088953464],
    [-99.23931716685371, 19.324683088953464],
    [-99.23958706868825, 19.324580809956444],
    [-99.2397692641402, 19.324511768103662],
    [-99.2402499149016, 19.32441183004198],
    [-99.24028798680109, 19.324407071729013],
    [-99.24040220070094, 19.324483213729366],
    [-99.2406734587131, 19.324763991065367],
    [-99.24107320916124, 19.325168498927155],
    [-99.24109700342393, 19.3253207847265],
    [-99.24183463635933, 19.326515274160613],
    [-99.24272455509413, 19.32795246813197],
    [-99.24306719679367, 19.328238003780882],
    [-99.24354308924217, 19.32846643158058],
    [-99.24360495540435, 19.328480709217388],
    [-99.24381910736588, 19.32844739563086],
    [-99.24423313275281, 19.32856161043003],
    [-99.2446376406146, 19.32845691405538],
    [-99.24502311432525, 19.32843787810566],
    [-99.24529913244896, 19.328180896830986],
    [-99.245399068712, 19.32813330740629],
    [-99.24553231856163, 19.328114272355833],
    [-99.24588923789798, 19.328123789881033],
    [-99.24634133608373, 19.328090477193825],
    [-99.24661735330818, 19.32803812855684],
    [-99.24723601313144, 19.3279381922938],
    [-99.2480164762793, 19.327871566919328],
    [-99.24831152855415, 19.327804942444175],
    [-99.2486256176781, 19.327690727645006],
    [-99.24866844789051, 19.327576513745157],
    [-99.24934897387601, 19.327210076883603],
    [-99.24996763369933, 19.32702923760928],
    [-99.25117639987093, 19.32704351434677],
    [-99.25135247993296, 19.327086344559177],
    [-99.25234709504235, 19.327091103771465],
    [-99.2529372013907, 19.32701972008408],
    [-99.25310852313982, 19.326981648184585],
    [-99.25334171015174, 19.326867434284736],
    [-99.25356062042624, 19.326862675072448],
    [-99.25393181560077, 19.32694833639664],
    [-99.25409361892531, 19.32695309470961],
    [-99.25469324369823, 19.3267579786978],
    [-99.25517389535895, 19.326558104373078],
    [-99.25540232315865, 19.326301123098403],
    [-99.25581634944496, 19.32573005180052],
    [-99.25590676908212, 19.32573005180052],
    [-99.25625892920618, 19.32522560587705],
    [-99.25633507210586, 19.32495434786489],
    [-99.25632079536837, 19.32474971432788],
    [-99.25652066969309, 19.324361386169073],
    [-99.25667485935725, 19.32410440399508],
    [-99.2572402190608, 19.32327635232184],
    [-99.25774847181447, 19.322613909904078],
    [-99.2579026605793, 19.32252253788488],
    [-99.25808540281906, 19.32239119190001],
    [-99.25844517840221, 19.32227126730521],
    [-99.25857081279275, 19.322128499930386],
    [-99.25871929176185, 19.322065682285483],
    [-99.25903909068143, 19.32183725358641],
    [-99.25921041243055, 19.32160311509176],
    [-99.25961016197937, 19.321334712427074],
    [-99.26037539690702, 19.3205694766001],
    [-99.26042679316191, 19.320483816175226],
    [-99.26057527123174, 19.320158305661323],
    [-99.26082083201572, 19.319895612792322],
    [-99.26103212773046, 19.319558681787782],
    [-99.26135192665004, 19.31882771103011],
    [-99.26159177673907, 19.31827948431078],
    [-99.26167172736831, 19.317839758997707],
    [-99.26175738689386, 19.317708413012895],
    [-99.26216855783264, 19.317365771313348],
    [-99.2624426720916, 19.317177316579944],
    [-99.26317364284932, 19.316309290041772],
    [-99.26349534563366, 19.316071343817498],
    [-99.26450042975102, 19.315332759399382],
    [-99.2646451009906, 19.315035802360455],
    [-99.2649649008095, 19.314807373661438],
    [-99.26523140140802, 19.314441889181865],
    [-99.26545221464795, 19.314160161262464],
    [-99.26587861380693, 19.313436805064555],
    [-99.26659435634446, 19.313505333404464],
    [-99.26711212662332, 19.313695690203986],
    [-99.2672720260831, 19.313771833103658],
    [-99.26750806934189, 19.313787061323865],
    [-99.26766035424191, 19.314091632023235],
    [-99.26762228324174, 19.314205845923084],
    [-99.26778218270152, 19.314213461382167],
    [-99.26801061140054, 19.31410686114276],
    [-99.26820096820006, 19.314068789243265],
    [-99.26847508155976, 19.314015489123562],
    [-99.26872635303874, 19.313855589663774],
    [-99.26897762361841, 19.31374899032369],
    [-99.26944209467689, 19.31363477642384],
    [-99.2699903231948, 19.31272106342641],
    [-99.27054616537322, 19.31194440710874],
    [-99.27049286525352, 19.311586536289667],
    [-99.27032535123396, 19.31183019230957],
    [-99.27114007765243, 19.30905859597749],
    [-99.27081266417309, 19.30875402527812],
    [-99.27128474889201, 19.308320011559317],
    [-99.27124667789184, 19.307170256202426],
    [-99.27074413583318, 19.30671339970371],
    [-99.27053093625369, 19.306644871363744],
    [-99.27042433601429, 19.30656111390431],
    [-99.27017561141531, 19.306106547978857],
    [-99.26998270773572, 19.305754001146283],
    [-99.26975427993602, 19.305738772026757],
    [-99.26868066657948, 19.305342830207508],
    [-99.26842178233937, 19.305129629728697],
    [-99.26916798131725, 19.304703230569658],
    [-99.26941163823648, 19.304611860349098],
    [-99.27037103589453, 19.304155002951063],
    [-99.27062230737357, 19.30398748893151],
    [-99.27080504961333, 19.30372860379208],
    [-99.27139896279186, 19.303089005053607],
    [-99.27221369100897, 19.302472248195727],
    [-99.27209947710912, 19.302418948076024],
    [-99.27149794937083, 19.3023199632957],
    [-99.2712923643511, 19.302091533697364],
    [-99.27047763613399, 19.301581377978266],
    [-99.27037103589453, 19.301413863958715],
    [-99.26973143715605, 19.301177820699934],
    [-99.27055377903366, 19.299700651863645],
    [-99.27148272115062, 19.29917526702502],
    [-99.27165023517017, 19.298360539707176],
    [-99.27149033481106, 19.298010283447866],
    [-99.27184820563014, 19.296129557333245],
    [-99.27206901976939, 19.29558132881533],
    [-99.27209947710912, 19.29550518591566],
    [-99.27232029124843, 19.295360514676076],
    [-99.27235836224861, 19.29499503019656],
    [-99.27248780526799, 19.294667615817843],
    [-99.2724649615887, 19.294210760218448],
    [-99.27276191862762, 19.293738674600206],
    [-99.27318070412616, 19.293144761421672],
    [-99.27473401586212, 19.291347791867167],
    [-99.27512377214435, 19.290730560167276],
    [-99.27616597577912, 19.2891030093964],
    [-99.27588519934244, 19.288712777372837],
    [-99.2750095582445, 19.287518287938667],
    [-99.27366754222328, 19.28566230756951],
    [-99.27331538119984, 19.285191175232626],
    [-99.27683222502714, 19.283211463438363],
    [-99.27788870539939, 19.282602321140246],
    [-99.27789346371236, 19.282002697266705],
    [-99.27792201808666, 19.28171716161779],
    [-99.27800292019856, 19.28155535829319],
    [-99.2781218933107, 19.281488732918717],
    [-99.27823134799826, 19.281417350130653],
    [-99.2783217667361, 19.281407831706133],
    [-99.27850260601042, 19.281493492131005],
    [-99.27864537428457, 19.28162674198063],
    [-99.27901181114612, 19.28171716161779],
    [-99.27919740873341, 19.28167908971824],
    [-99.27940204316974, 19.281469697868317],
    [-99.27963523018167, 19.28116036795666],
    [-99.28001118456848, 19.280960492732618],
    [-99.28022057731778, 19.280827242882992],
    [-99.28044172780346, 19.28076857111273],
    [-99.2804537643297, 19.280765376720808],
    [-99.28079640692857, 19.28076061840784],
    [-99.28114380784041, 19.280622610245302],
    [-99.28132464711473, 19.280189548009275],
    [-99.28150072717676, 19.279499503599254],
    [-99.28206228005013, 19.279228244687772],
    [-99.28231164766436, 19.27902837126237],
    [-99.28245631890394, 19.278780906613576],
    [-99.28305403891272, 19.27775678744581],
    [-99.28348805263147, 19.277273280437612],
    [-99.28397155963972, 19.27696490200867],
    [-99.28392587407978, 19.27670601686924],
    [-99.28376216689043, 19.27623393215032],
    [-99.28331673178172, 19.27600169572173],
    [-99.2831834819321, 19.27573900375205],
    [-99.28322155293228, 19.275430626222487],
    [-99.28332053861192, 19.275103211843827],
    [-99.28342333202113, 19.27501945528371],
    [-99.28375455323004, 19.27475295468514],
    [-99.28405531709916, 19.274596862954922],
    [-99.28471395088809, 19.273568935158266],
    [-99.28494237958711, 19.273279592679103],
    [-99.2852469511858, 19.27311207865955],
    [-99.28528616432499, 19.272900782944816],
    [-99.2854175103098, 19.272186944272107],
    [-99.28542893169981, 19.271827169588278],
    [-99.28565736039883, 19.27140457815881],
    [-99.28618845593246, 19.27069073858678],
    [-99.28681663328098, 19.270416625227142],
    [-99.28751048362187, 19.270170112960386],
    [-99.28789119812024, 19.270165353748155],
    [-99.28818149208217, 19.270165353748155],
    [-99.28857172410574, 19.270217702385082],
    [-99.28932839299091, 19.270350952234708],
    [-99.28963296369028, 19.270293845284755],
    [-99.28995181112714, 19.270084453434833],
    [-99.29092739028681, 19.26920405222529],
    [-99.29122244256166, 19.269047008112977],
    [-99.29166502322221, 19.268766230776976],
    [-99.29225988788346, 19.268537802977278],
    [-99.29258349543193, 19.26830461596529],
    [-99.29274054044356, 19.267643125929567],
    [-99.29289948842063, 19.267489887748184],
    [-99.29352005120938, 19.266888360909206],
    [-99.29379035773877, 19.26635916924033],
    [-99.29401878643779, 19.266035561691865],
    [-99.29406066516754, 19.265571090633387],
    [-99.29398832909806, 19.265281749053543],
    [-99.29419010728759, 19.264901034555123],
    [-99.29423959967772, 19.264596463855753],
    [-99.29477259907617, 19.264067272186935],
    [-99.29509620572526, 19.263808386148128],
    [-99.29556448361399, 19.2636028011284],
    [-99.296230732862, 19.263305844089473],
    [-99.29682083921034, 19.26311548728995],
    [-99.29697312500969, 19.262704316351176],
    [-99.29728531026882, 19.26229314631172],
    [-99.29775739498774, 19.26189339586358],
    [-99.29799724507677, 19.261442250059815],
    [-99.2984845580159, 19.261305193379997],
    [-99.29899471463432, 19.26122143592056],
    [-99.29978660007151, 19.260886407881458],
    [-99.30022822655138, 19.26093970800116],
    [-99.30058609826978, 19.26109960836027],
    [-99.30087544074894, 19.26103107912104],
    [-99.30101249832808, 19.260878794221014],
    [-99.30147696938661, 19.26052092340194],
    [-99.30172062540652, 19.26000315222376],
    [-99.3019185967658, 19.25951583928463],
    [-99.30215463912526, 19.25936355258591],
    [-99.30236783870475, 19.258937154326247],
    [-99.30303789478296, 19.258678268287497],
    [-99.3035175940617, 19.258678268287497],
    [-99.30384500844036, 19.258396540368096],
    [-99.3051089776971, 19.257992983989084],
    [-99.30622827571432, 19.25774932706986],
    [-99.30689928417456, 19.25777787964546],
    [-99.30791531394055, 19.25796347813207],
    [-99.30877905880646, 19.258101487193926],
    [-99.30926922799244, 19.2578183311511],
    [-99.30973560201636, 19.257592282058226],
    [-99.31020435564648, 19.257275814227512],
    [-99.31075639099464, 19.257183014984207],
    [-99.31120372906878, 19.257073560296647],
    [-99.31227068024765, 19.257084505045896],
    [-99.3125505043023, 19.256944593018602],
    [-99.31279606508627, 19.256707599176423],
    [-99.31353274563969, 19.25665049222647],
    [-99.31375831899118, 19.256653346674682],
    [-99.31392392914597, 19.256753283837043],
    [-99.31408668395329, 19.256816102381265],
    [-99.31421232014242, 19.25682752377128],
    [-99.31438364099222, 19.25681324703379],
    [-99.31460635899623, 19.256724731261386],
    [-99.31476911380355, 19.25651343464733],
    [-99.31501181924006, 19.25649059186736],
    [-99.3152459577347, 19.256424918874984],
    [-99.31536017163455, 19.25636781192503],
    [-99.31546867483945, 19.25614509392102],
    [-99.31548009712873, 19.25602802467364],
    [-99.31543441066947, 19.25590524473131],
    [-99.3152716558622, 19.25578246388966],
    [-99.31515173126735, 19.25563684116736],
    [-99.31501181924006, 19.25548265240252],
    [-99.31487476166086, 19.255351306417708],
    [-99.31478624588851, 19.255228525576058],
    [-99.31477196915102, 19.25497439874954],
    [-99.31488047235587, 19.254840198316572],
    [-99.31500039695072, 19.254640323092474],
    [-99.3151945605805, 19.254349076748554],
    [-99.31526023357287, 19.253957894141536],
    [-99.31534304044891, 19.2537465984268],
    [-99.31549722921375, 19.253312583808736],
    [-99.31571994631844, 19.25301562676981],
    [-99.31587699133007, 19.252918544954923],
    [-99.31594266432245, 19.252798620360068],
    [-99.31595123036493, 19.252621587915996],
    [-99.31585700299826, 19.252458833108733],
    [-99.3158827011257, 19.252338907614558],
    [-99.31597978294059, 19.252159020722274],
    [-99.31605973267051, 19.25208763703489],
    [-99.31607972100227, 19.25201625334745],
    [-99.31606829871299, 19.25194772500754],
    [-99.3159712168981, 19.251827800412684],
    [-99.31590840015252, 19.25165647866362],
    [-99.31593124203317, 19.25153369872129],
    [-99.31595694105994, 19.251296703979733],
    [-99.315916966195, 19.250985471102638],
    [-99.31591410994815, 19.250928364152742],
    [-99.31596265085562, 19.25084841442282],
    [-99.31603118009485, 19.250836993032863],
    [-99.31613397260469, 19.250845559075344],
    [-99.31618251441148, 19.250859834913513],
    [-99.31633670317626, 19.25103401201011],
    [-99.31638809943121, 19.251051144095072],
    [-99.31644235103363, 19.251036867357584],
    [-99.31658511840845, 19.25080272796356],
    [-99.31662794862092, 19.250739911217977],
    [-99.3167078992501, 19.250785595878597],
    [-99.31678213828502, 19.25078845212539],
    [-99.31707338372962, 19.250311608194238],
    [-99.3170448302547, 19.250048915325237],
    [-99.31701056608472, 19.249709128073846],
    [-99.3169905777529, 19.24915233441277],
    [-99.31711335859461, 19.248635514717307],
    [-99.31729324638616, 19.248047313133043],
    [-99.31741317098101, 19.247827449577187],
    [-99.3175245304327, 19.247610443167446],
    [-99.31777294476558, 19.247364883282785],
    [-99.31780149913982, 19.247287788900394],
    [-99.31784432935228, 19.247133599236292],
    [-99.31784432935228, 19.247073636938865],
    [-99.31771012801994, 19.246396917783557],
    [-99.31757878113581, 19.24616848998386],
    [-99.31756450439832, 19.246082829558986],
    [-99.31758449183081, 19.246020011914084],
    [-99.31773011455311, 19.245928639894885],
    [-99.31779578844487, 19.24566880327268],
    [-99.31750454210089, 19.245306173241374],
    [-99.31751596259159, 19.24502349293988],
    [-99.31757878113581, 19.244715115410315],
    [-99.3176358880857, 19.24450096434805],
    [-99.31770156107814, 19.24438103885393],
    [-99.31788430421722, 19.244175453834202],
    [-99.31828405286672, 19.243721451783642],
    [-99.31837923171611, 19.243500637644388],
    [-99.31850867473554, 19.24334073908392],
    [-99.31876755987497, 19.24319606694496],
    [-99.31884370277464, 19.243226525184014],
    [-99.31924725915366, 19.243454952983768],
    [-99.31942238773297, 19.243439723864242],
    [-99.31978025855204, 19.24331789630395],
    [-99.32003153003103, 19.243180838724754],
    [-99.32017620127061, 19.243059010265142],
    [-99.32083864278911, 19.24223666928691],
    [-99.32195794080627, 19.241086913030642],
    [-99.32264322600406, 19.240386399612703],
    [-99.32271175524329, 19.240256956593328],
    [-99.32316861084269, 19.239259487035724],
    [-99.32316861084269, 19.239099586676616],
    [-99.32326759742165, 19.23868841573784],
    [-99.32331328208227, 19.238536130837815],
    [-99.32323714008191, 19.238300087579034],
    [-99.3231000834021, 19.238201102798712],
    [-99.32296302582296, 19.238155417238772],
    [-99.32287926926284, 19.238071659779337],
    [-99.32285642558355, 19.237957445879488],
    [-99.32284119736335, 19.23775186085976],
    [-99.32278028268388, 19.23763764695991],
    [-99.32272698256418, 19.237508203940536],
    [-99.32284881102379, 19.236746775843073],
    [-99.32295160443294, 19.236487890703643],
    [-99.3230087113829, 19.235951085374325],
    [-99.32272317573393, 19.235654128335398],
    [-99.32276886219319, 19.235151586276743],
    [-99.32266606878403, 19.2341350798701],
    [-99.32255185488418, 19.233952336731022],
    [-99.32256327627414, 19.23378101588122],
    [-99.32226631923521, 19.23271591190985],
    [-99.32272830636623, 19.23271591190985],
    [-99.32431142972865, 19.23271591190985],
    [-99.32431142972865, 19.23472009695496],
    [-99.32385457412926, 19.245399118174817],
    [-99.32351193063107, 19.25031032576095],
    [-99.32365469890522, 19.265186715894288],
    [-99.31885770521887, 19.273153150697397],
    [-99.3173443683479, 19.27483781021681],
    [-99.31711593964889, 19.276065612338186],
    [-99.31717304659878, 19.277064984861227],
    [-99.31683040489924, 19.277664608734767],
    [-99.31694461879908, 19.27815001870846],
    [-99.31674474357504, 19.279320713879883],
    [-99.3162022266514, 19.27983467822787],
    [-99.3161451197015, 19.28066272990111],
    [-99.31568826320273, 19.282118959822185],
    [-99.31585958495185, 19.2837750649673],
    [-99.31623078012638, 19.284346136265242],
    [-99.3166305296752, 19.286030793986015],
    [-99.31660197620022, 19.28720148915744],
    [-99.31617367317642, 19.28768689913113],
    [-99.3159737988517, 19.289028915152358],
    [-99.31574537015268, 19.289856967724916],
    [-99.31643065535042, 19.290770680722403],
    [-99.31654486925027, 19.291084768946973],
    [-99.31668763662509, 19.291741500669787],
    [-99.31705883269893, 19.292655213667217],
    [-99.3171349755986, 19.29342615928988],
    [-99.31702076169876, 19.29392108678877],
    [-99.31710451915819, 19.294256114827874],
    [-99.31695223335885, 19.29464444298668],
    [-99.31715781837858, 19.295086071265246],
    [-99.31715781837858, 19.295832270243125],
    [-99.3167847193393, 19.29699725382028],
    [-99.31645730496064, 19.29741603931882],
    [-99.31623649082138, 19.29812416729652],
    [-99.31622126260118, 19.298337366876012],
    [-99.31611466326109, 19.298641937575383],
    [-99.3159776056819, 19.29890082271487],
    [-99.31589384912178, 19.299144479634094],
    [-99.31594714924148, 19.299372908333112],
    [-99.31627456272088, 19.29972316459242],
    [-99.31640400484093, 19.299875450391767],
    [-99.3164268476209, 19.299989664291616],
    [-99.31641923396046, 19.300058192631525],
    [-99.31600044936124, 19.30032469233072],
    [-99.31568826320273, 19.300621649369646],
    [-99.31533039238366, 19.301002362968745],
    [-99.31515526380434, 19.301276477227702],
    [-99.31471363642515, 19.30145921856814],
    [-99.31461465074551, 19.30143637668749],
    [-99.31434053738587, 19.301375462008025],
    [-99.31411972324662, 19.30139069112755],
    [-99.31395982288745, 19.301451604907697],
    [-99.31392175188728, 19.301603890707042],
    [-99.31389890910731, 19.302456689924327],
    [-99.31389129364823, 19.303096288662857],
    [-99.31364002306856, 19.303553145161573],
    [-99.31325931036884, 19.30394147332038],
    [-99.31293189599018, 19.304169901120076],
    [-99.31208671133265, 19.304169901120076],
    [-99.31197249743275, 19.304352644259154],
    [-99.31205625399286, 19.304672444078108],
    [-99.31214001055304, 19.304969400217715],
    [-99.31228468179262, 19.305228286256465],
    [-99.31222376801247, 19.305555699735805],
    [-99.31202579665313, 19.306027785354047],
    [-99.31195726921254, 19.306393269833563],
    [-99.31160701205391, 19.306796826212633],
    [-99.31140904069463, 19.3069110410118],
    [-99.31127198401481, 19.30688819823183],
    [-99.31083797029606, 19.306728297872723],
    [-99.31068568539604, 19.306796826212633],
    [-99.31061715615681, 19.30693388289245],
    [-99.3104572557977, 19.30739835395093],
    [-99.3103506555583, 19.30751256785078],
    [-99.31019075699783, 19.307596325310215],
    [-99.31008415675836, 19.30756586797048],
    [-99.3094978581396, 19.306964340232184],
    [-99.30942171523992, 19.30678921165287],
    [-99.30934557234025, 19.30638565617312],
    [-99.30935318600069, 19.30591356965556],
    [-99.30938364334042, 19.305746055636007],
    [-99.30943694256081, 19.305578541616455],
    [-99.30945217168033, 19.305487171395896],
    [-99.30929227222055, 19.305228286256465],
    [-99.30907907174173, 19.30509884323709],
    [-99.30880495928142, 19.305083614117564],
    [-99.308218658864, 19.305418643055987],
    [-99.30795977372452, 19.305578541616455],
    [-99.30776180326455, 19.305883113215145],
    [-99.30754860278574, 19.30652271195362],
    [-99.30738870332596, 19.30690342555272],
    [-99.30738108876619, 19.307710539210063],
    [-99.30738870332596, 19.30786282500941],
    [-99.30724403208637, 19.3079846525697],
    [-99.30699276060739, 19.307954196129288],
    [-99.30685570392757, 19.30781713944947],
    [-99.30636839098844, 19.30723083993138],
    [-99.30608666216966, 19.307169926151232],
    [-99.3059572200496, 19.307223226270935],
    [-99.30577447691053, 19.307390740290487],
    [-99.30504350705218, 19.309050652265853],
    [-99.30492929225301, 19.30918770894567],
    [-99.30471609267352, 19.309225779945848],
    [-99.30442675019435, 19.309378065745193],
    [-99.30428207895477, 19.30943898042466],
    [-99.30347496619669, 19.310977063041094],
    [-99.30339120873725, 19.311091277840262],
    [-99.30323130927746, 19.31115219162041],
    [-99.30306379525791, 19.31110650606047],
    [-99.30230998172027, 19.310246093182684],
    [-99.3017465249821, 19.30953035064522],
    [-99.30147241162246, 19.30943898042466],
    [-99.30133535494264, 19.309499894204805],
    [-99.30124398292344, 19.309690251004326],
    [-99.30125921204296, 19.31136539209922],
    [-99.30108408436297, 19.312202962196977],
    [-99.30100794056398, 19.31227910509665],
    [-99.30049778394556, 19.3124466191162],
    [-99.30007138478652, 19.31352784613324],
    [-99.30003331378634, 19.313999930852162],
    [-99.30007899934628, 19.31434257255171],
    [-99.30058915596476, 19.31549994336774],
    [-99.30071288828913, 19.31604436415614],
    [-99.30113357585378, 19.31691429455907],
    [-99.3011354797186, 19.317052302721663],
    [-99.30117355071877, 19.317366391845553],
    [-99.30119496627464, 19.317480605745402],
    [-99.30125921204296, 19.31770903534374],
    [-99.30132583741744, 19.317811351212924],
    [-99.3016446848543, 19.318123060730727],
    [-99.30174938122894, 19.318196824024255],
    [-99.30180648817884, 19.318287243661416],
    [-99.30177317459231, 19.31848949759228],
    [-99.30170179180419, 19.318582296835586],
    [-99.30158281869211, 19.318615608623475],
    [-99.3013496307808, 19.318615608623475],
    [-99.30125683243682, 19.318706029159955],
    [-99.30118544874944, 19.31888210922199],
    [-99.30116641279966, 19.318974907565973],
    [-99.30112358258725, 19.319139091395982],
    [-99.30110454663748, 19.319236648952256],
    [-99.30110454663748, 19.319443662095352],
    [-99.30105457760664, 19.31968636663254],
    [-99.30081187306945, 19.319974280988333],
    [-99.30080235464493, 19.320005214069397],
    [-99.30066196687625, 19.320221744737808],
    [-99.30059296279495, 19.32044779383068],
    [-99.30059058318881, 19.320626254398178],
    [-99.3006286550883, 19.32092130667303],
    [-99.30056202971389, 19.32132105622179],
    [-99.30049540523873, 19.321478101233424],
    [-99.30050254315779, 19.321649422083226],
    [-99.3005477529764, 19.321782671932795],
    [-99.30057392684523, 19.322087242632165],
    [-99.30056202971389, 19.32221097495659],
    [-99.30046447215761, 19.32230139369443],
    [-99.30033360191413, 19.32234422480616],
    [-99.30016941898344, 19.32231567133124],
    [-99.30007424013405, 19.32223476921928],
    [-99.29995050780963, 19.32206582797562],
    [-99.29980536082871, 19.321892126620412],
    [-99.29961500402919, 19.321504275102257],
    [-99.29931043332982, 19.321273466797095],
    [-99.29907962592398, 19.321183048059254],
    [-99.29899396459973, 19.321068834159405],
    [-99.29884167880039, 19.3206667050045],
    [-99.2986822559813, 19.319926691563637],
    [-99.29856328286917, 19.319672089895107],
    [-99.29835389011987, 19.319396071771337],
    [-99.29814449737063, 19.31916764397164],
    [-99.29775426624633, 19.318920180222165],
    [-99.29752583844663, 19.31893921617194],
    [-99.29719271337297, 19.31888210922199],
    [-99.2970213916239, 19.318805966322316],
    [-99.29688814177428, 19.318729823422643],
    [-99.29671682092453, 19.318606091098275],
    [-99.29638369585086, 19.31822537839855],
    [-99.29639892497039, 19.318074995564643],
    [-99.29639321427538, 19.31799504583472],
    [-99.29654740304017, 19.317429686131163],
    [-99.29656453512519, 19.317383999671904],
    [-99.2965017165809, 19.317269785772055],
    [-99.29643318914032, 19.31719554673714],
    [-99.29633610732543, 19.317178414652176],
    [-99.29609625723646, 19.31719554673714],
    [-99.29584498575747, 19.31736686758694],
    [-99.29558229378779, 19.317532478641],
    [-99.29549092176859, 19.317561032115975],
    [-99.29536528737805, 19.317532478641],
    [-99.29522251910396, 19.31738971126623],
    [-99.29512543728907, 19.317235521602072],
    [-99.29497124762491, 19.317001383107367],
    [-99.29490272018433, 19.316938564563145],
    [-99.29474281982522, 19.31691001198749],
    [-99.29455436689051, 19.317001383107367],
    [-99.2943887558364, 19.317515345656716],
    [-99.29419459220662, 19.317892253324885],
    [-99.29421172429159, 19.31794936027478],
    [-99.29397758489756, 19.318286292178698],
    [-99.29374915709786, 19.31886307327227],
    [-99.29356070416316, 19.319736811404766],
    [-99.29349788561888, 19.319913842949518],
    [-99.29332656476913, 19.32030217110838],
    [-99.2930238970352, 19.320599128147308],
    [-99.29261272609642, 19.3208656278465],
    [-99.29213302681768, 19.321033141866053],
    [-99.2912802276004, 19.321208270445368],
    [-99.29074722910133, 19.32130725612501],
    [-99.29046550118187, 19.32158898404441],
    [-99.29042742928237, 19.32203822598342],
    [-99.2905568723018, 19.32225142556291],
    [-99.29102134336028, 19.322495081582815],
    [-99.29117362826031, 19.32253315438163],
    [-99.29143251429906, 19.322753967621566],
    [-99.29160002831861, 19.323477323819475],
    [-99.29178276965905, 19.32440626593649],
    [-99.29167617121828, 19.324954492655763],
    [-99.29144774161995, 19.325434192833768],
    [-99.29079291466127, 19.32656871997051],
    [-99.29075484276177, 19.32705603290964],
    [-99.29137921417936, 19.328556046324536],
    [-99.29137921417936, 19.328784474124234],
    [-99.2912117001598, 19.32933270174283],
    [-99.29022945792309, 19.33063474289912],
    [-99.28958224462485, 19.331967241395148],
    [-99.28862284606748, 19.333063695733017],
    [-99.2882687820786, 19.333372075061277],
    [-99.28802893288889, 19.333520553131052],
    [-99.28781192557989, 19.333497710351082],
    [-99.28766344840938, 19.333360652771944],
    [-99.28764060473009, 19.333246438872095],
    [-99.28764060473009, 19.33300658878312],
    [-99.28823451790862, 19.331784498256013],
    [-99.28839441826773, 19.33121342785745],
    [-99.2883601540978, 19.33069946440878],
    [-99.28821167512865, 19.330459614319807],
    [-99.28783476925918, 19.33020834284082],
    [-99.28685252702246, 19.32978575141135],
    [-99.28665836339275, 19.32976290773206],
    [-99.28679542007256, 19.3298999653112],
    [-99.28740075464106, 19.330528142659716],
    [-99.2875378122202, 19.330870785258583],
    [-99.28751496944022, 19.33114489861822],
    [-99.28604160743419, 19.334068780749703],
    [-99.28505650985, 19.336490119923155],
    [-99.28448543855211, 19.336718548622173],
    [-99.28354317297902, 19.3366328881973],
    [-99.28257235303164, 19.33594760299951],
    [-99.28165864003415, 19.335576406925668],
    [-99.28040228443786, 19.335090996951976],
    [-99.28015558241418, 19.33529658287108],
    [-99.28001852483504, 19.33603897411939],
    [-99.28009847456491, 19.336427303177572],
    [-99.2806809672528, 19.336781366267076],
    [-99.28112640236156, 19.337112586576666],
    [-99.28116066563217, 19.337443807785576],
    [-99.28079518115266, 19.337363858055653],
    [-99.28044111716378, 19.337352436665697],
    [-99.2800642112943, 19.337432387294882],
    [-99.2798015184253, 19.337580865364714],
    [-99.27965304035547, 19.33763797231461],
    [-99.2792418694167, 19.337580865364714],
    [-99.27855658421896, 19.33772934433381],
    [-99.27726596355336, 19.338334678003037],
    [-99.2759410796171, 19.33886006284166],
    [-99.27543853755844, 19.33904280598074],
    [-99.27506163168891, 19.339248391000467],
    [-99.27470756770003, 19.339385447680343],
    [-99.27426213259133, 19.33952250525948],
    [-99.27331415632324, 19.340059312387382],
    [-99.27298293511433, 19.34015068260794],
    [-99.27286872031516, 19.340207789557894],
    [-99.27237759964646, 19.340516167986834],
    [-99.2720692221169, 19.340607540006033],
    [-99.27162378610882, 19.34081312502576],
    [-99.2709042367411, 19.341087239284718],
    [-99.27069865172137, 19.341167189014584],
    [-99.27029509534236, 19.34142607415407],
    [-99.26996197116802, 19.341587878377936],
    [-99.26987630984377, 19.341706850590754],
    [-99.26978589110593, 19.341797270227914],
    [-99.26947180198204, 19.342011422189444],
    [-99.26933379292018, 19.34205425240185],
    [-99.26920054307055, 19.34195907265314],
    [-99.26897211527086, 19.34188768986502],
    [-99.26872940983435, 19.341849617965522],
    [-99.26854857056003, 19.341840100440322],
    [-99.26839152734709, 19.341882930652787],
    [-99.26830586602284, 19.341987627027436],
    [-99.26815833943579, 19.342097081714996],
    [-99.26763961677489, 19.342725259962833],
    [-99.26724938475127, 19.34337723157404],
    [-99.26693053821373, 19.343800776284866],
    [-99.26681632341456, 19.344038721609763],
    [-99.26678301072735, 19.34407203519629],
    [-99.26661168987755, 19.344129142146244],
    [-99.265988270842, 19.34405775755954],
    [-99.26587405694215, 19.34406727598406],
    [-99.26575032461773, 19.344138659671444],
    [-99.26565990498057, 19.344295703783757],
    [-99.26563611071788, 19.344409917683606],
    [-99.26553141434329, 19.344524131583455],
    [-99.26538864696846, 19.34459551617016],
    [-99.26514118321899, 19.344633588069712],
    [-99.2650317276321, 19.344662140645312],
    [-99.26492227204517, 19.344714489282296],
    [-99.26487944183276, 19.344809668131745],
    [-99.26488420104499, 19.344957193819482],
    [-99.26488420104499, 19.345042855143674],
    [-99.26486516509527, 19.3451761049933],
    [-99.26476046872062, 19.34527604215566],
    [-99.26471763940748, 19.345314113155837],
    [-99.26455107687065, 19.34526652373114],
    [-99.26441782702108, 19.345237971155484],
    [-99.26433692490912, 19.345237971155484],
    [-99.26418939832206, 19.345342666630813],
    [-99.26416560405937, 19.34546163974295],
    [-99.2641465681096, 19.345951808928874],
    [-99.26406566599763, 19.346027951828546],
    [-99.26392289862281, 19.346056505303522],
    [-99.26364688139842, 19.3460755412533],
    [-99.26348507807387, 19.346118370566387],
    [-99.26333279317384, 19.346251621315332],
    [-99.26329947958726, 19.3463848711649],
    [-99.26322809589988, 19.34665137086415],
    [-99.26317098894992, 19.346737031289024],
    [-99.26311864121226, 19.34679889655189],
    [-99.26296635631223, 19.34688931708837],
    [-99.26282834725038, 19.34687504035088],
    [-99.26271413335053, 19.34679413823892],
    [-99.26257612428867, 19.34670371860176],
    [-99.26243811522681, 19.346665646702263],
    [-99.26230010616496, 19.34669420107656],
    [-99.26214306205264, 19.346760825551712],
    [-99.26204312489028, 19.34689883461357],
    [-99.26190987504066, 19.34697021830101],
    [-99.26167668802867, 19.347041601988394],
    [-99.26156723244179, 19.347046361200682],
    [-99.26138639316747, 19.347032083563874],
    [-99.26127217926762, 19.34711298567578],
    [-99.26118175963046, 19.34717485183802],
    [-99.26087718893109, 19.34718437026254],
    [-99.26078201008164, 19.347246236424724],
    [-99.26072490313175, 19.347312860899876],
    [-99.26066303696956, 19.347450869062413],
    [-99.26058689496921, 19.347517494436886],
    [-99.26043460916986, 19.347541288699574],
    [-99.26025376989554, 19.347522252749798],
    [-99.25995871672137, 19.347617431599247],
    [-99.25982546687175, 19.347750682348135],
    [-99.2597112529719, 19.347798270873568],
    [-99.25900693182439, 19.348036217097786],
    [-99.25895934329901, 19.34810760078517],
    [-99.25896410161198, 19.34818374278558],
    [-99.25903548619868, 19.348231333109595],
    [-99.25918586813327, 19.348174226159642],
    [-99.2596579528522, 19.347976253901038],
    [-99.25977216675204, 19.3479648334104],
    [-99.260046281011, 19.348037168580504],
    [-99.26013003757112, 19.34805239680071],
    [-99.26031278071025, 19.348067625920237],
    [-99.26056785901943, 19.348014325800534],
    [-99.26080390137889, 19.34788868961141],
    [-99.26096760766893, 19.347759248390673],
    [-99.26107040107809, 19.347732597881134],
    [-99.2611198943676, 19.34777447571156],
    [-99.2611198943676, 19.347831582661456],
    [-99.2610285223484, 19.347957218850638],
    [-99.2605526298999, 19.34821229715982],
    [-99.26035085171043, 19.348254175889565],
    [-99.25990541660167, 19.34828844005949],
    [-99.2597264811921, 19.3483569683994],
    [-99.25951328161261, 19.348638696318858],
    [-99.25939906771276, 19.348867125017875],
    [-99.25923155369321, 19.34906509637716],
    [-99.2589384043838, 19.349263066837125],
    [-99.25858814722517, 19.349449616806396],
    [-99.25828357562648, 19.34963235904621],
    [-99.25819601223611, 19.349754188405143],
    [-99.25819981906636, 19.34987982279563],
    [-99.2582455046263, 19.349986423035034],
    [-99.25833306891599, 19.35007017959515],
    [-99.25837875537525, 19.350077794154913],
    [-99.25894982487449, 19.349975001645078],
    [-99.25906403877434, 19.349963580255064],
    [-99.25915541079354, 19.349986423035034],
    [-99.25925439557386, 19.350062565934707],
    [-99.25930769569356, 19.350123479714853],
    [-99.25939525998325, 19.350428051313543],
    [-99.25934196076287, 19.350584143943138],
    [-99.25929627520293, 19.35077450074266],
    [-99.25920109635348, 19.3515283142803],
    [-99.2592658178632, 19.351947098879577],
    [-99.25931531115265, 19.352099383779603],
    [-99.2594295250525, 19.35260954129734],
    [-99.25947140288292, 19.35284558275748],
    [-99.2597112529719, 19.3537098042641],
    [-99.25991683799163, 19.354574023972077],
    [-99.26002026632221, 19.35511273406547],
    [-99.26000123037244, 19.355265018965497],
    [-99.26016303279766, 19.355902714738534],
    [-99.26044856934595, 19.35765399783378],
    [-99.261015832015, 19.360417979606098],
    [-99.26114146820419, 19.360863414714856],
    [-99.26149553129369, 19.361286007942965],
    [-99.2621237086422, 19.361731443051724],
    [-99.26272904411007, 19.36209692843056],
    [-99.26427093535534, 19.36258804909926],
    [-99.26586993175192, 19.36314769810781],
    [-99.26677222425872, 19.363536026266672],
    [-99.26650953228904, 19.364107096665236],
    [-99.2664410030498, 19.364975124102727],
    [-99.2667036959188, 19.36641422193884],
    [-99.26677222425872, 19.367293670766344],
    [-99.26671511730876, 19.367910426724848],
    [-99.26626968220006, 19.369121096761262],
    [-99.26542449664316, 19.371097000825955],
    [-99.26508185494362, 19.371736599564485],
    [-99.26539023337256, 19.372033556603412],
    [-99.2655958192916, 19.37204497799337],
    [-99.26617831108018, 19.371531015444077],
    [-99.26630394636999, 19.371051316165335],
    [-99.26681790981866, 19.370034809758693],
    [-99.26722908075743, 19.369338104070323],
    [-99.2677430442061, 19.368915510842214],
    [-99.26800573707504, 19.368721347212443],
    [-99.2683940652339, 19.368709925822486],
    [-99.26918214204221, 19.369075411201322],
    [-99.26879381388335, 19.36947516075014],
    [-99.26863391442356, 19.369600796039947],
    [-99.26837122155462, 19.370160445048555],
    [-99.26819990070481, 19.370765779617102],
    [-99.2682912718247, 19.371451064814835],
    [-99.2684625926745, 19.371782286023745],
    [-99.26967326271085, 19.371485328984818],
    [-99.26976463383073, 19.371485328984818],
    [-99.27017580476956, 19.372444728441508],
    [-99.27016438427887, 19.372901584040903],
    [-99.26993595468053, 19.3732213838598],
    [-99.26958189159097, 19.373472655338844],
    [-99.26865675720353, 19.373586869238693],
    [-99.26814279375492, 19.37346123394883],
    [-99.2677430442061, 19.373347019149662],
    [-99.26745750855713, 19.373472655338844],
    [-99.26724050214744, 19.373609712018663],
    [-99.26694354510846, 19.374077989907335],
    [-99.26668085313884, 19.37435210416635],
    [-99.26615546830021, 19.374534846406107],
    [-99.26333437867862, 19.374923173665593],
    [-99.26288894356986, 19.3750830740247],
    [-99.26098156784502, 19.37611100092198],
    [-99.26033054681727, 19.376567858320072],
    [-99.2576579370641, 19.378897826373645],
    [-99.25692696630642, 19.37959453206207],
    [-99.25544218291037, 19.3805996170787],
    [-99.2500512760455, 19.38404888314949],
    [-99.24761183801587, 19.386012579816736],
    [-99.24729871476382, 19.386264637303213],
    [-99.24619464496686, 19.3871783503007],
    [-99.2456426096187, 19.38740677899972],
    [-99.2450144331695, 19.387444849999895],
    [-99.24391036337255, 19.38708317235057],
    [-99.24349157787401, 19.386930885651907],
    [-99.2428824355759, 19.386968957551403],
    [-99.24206390142785, 19.38742581405012],
    [-99.24134054522995, 19.388111099247908],
    [-99.24016033163394, 19.38872024064665],
    [-99.23962733313488, 19.389139026145187],
    [-99.23899915488704, 19.39064284639028],
    [-99.23901819083682, 19.39153752343799],
    [-99.23907529778671, 19.39243219958638],
    [-99.23892301198737, 19.392812914084743],
    [-99.23783797814013, 19.39353627028271],
    [-99.23743822859132, 19.3936314491321],
    [-99.23623897994491, 19.393517235232252],
    [-99.23578212434552, 19.3936314491321],
    [-99.23250798595473, 19.394925874829312],
    [-99.23149909410785, 19.39486876787936],
    [-99.23104223760913, 19.39484973282896],
    [-99.23003334576225, 19.395268518327498],
    [-99.2275206345696, 19.395801516826566],
    [-99.22668306537116, 19.395801516826566],
    [-99.22592163817302, 19.395706338876494],
    [-99.22510310312566, 19.395611160027045],
    [-99.22396096232853, 19.395801516826566],
    [-99.2217528218352, 19.39644873012486],
    [-99.2163276508004, 19.39818097816965],
    [-99.21488569671749, 19.398728254305524],
    [-99.21364837797023, 19.399227941016704],
    [-99.21243485258634, 19.39984660084002],
    [-99.21029333836685, 19.400512850088035],
    [-99.20746177883797, 19.40098874163715],
    [-99.20170157526746, 19.401594333411822],
    [-99.20052136167146, 19.402165403810386],
    [-99.19766600877927, 19.403155259707546],
    [-99.19214565979433, 19.403802473005783],
    [-99.19225987369418, 19.401327833712628],
    [-99.19092737609748, 19.399766907416904],
    [-99.1892350030929, 19.395801200265225]
  ],
  [
    // ID Cuajimalpa: V1-C-516
    [-99.25579486104397, 19.403560359323194],
    [-99.2554090114167, 19.40267710006816],
    [-99.2553852162547, 19.40208223540691],
    [-99.25521865371786, 19.401511164108967],
    [-99.25545659994208, 19.400392816675208],
    [-99.25524244887987, 19.39936964899016],
    [-99.25521865371786, 19.398774784328907],
    [-99.25569454616635, 19.39718054534592],
    [-99.25647976762713, 19.39646670667321],
    [-99.25831195283433, 19.39513420907656],
    [-99.25962065706761, 19.394372780979097],
    [-99.25969204075506, 19.39406345106744],
    [-99.25919235404388, 19.392659568884028],
    [-99.25903245368477, 19.392460646042025],
    [-99.2587278829854, 19.392414961381405],
    [-99.25842331228597, 19.392719532080775],
    [-99.2577989417677, 19.392734760300982],
    [-99.25656542895138, 19.392856587861274],
    [-99.25607811511287, 19.39329821613984],
    [-99.25592583021285, 19.393450501939185],
    [-99.25516440211544, 19.393587558619004],
    [-99.25426591823748, 19.39409010067766],
    [-99.2544029749173, 19.394364214936616],
    [-99.25484460319586, 19.394760156755865],
    [-99.25496643075616, 19.39504950013435],
    [-99.25484460319586, 19.39529315705363],
    [-99.2545704889369, 19.39524747059437],
    [-99.25358063303975, 19.394409901395875],
    [-99.25294103430127, 19.393572330398797],
    [-99.25132680788585, 19.393480959278918],
    [-99.25082426492787, 19.393678929738883],
    [-99.2500476086102, 19.393709387078616],
    [-99.2491643529525, 19.393404816379245],
    [-99.24864658267364, 19.393633245078263],
    [-99.24817449795466, 19.394135787136918],
    [-99.24780901167651, 19.39434898581709],
    [-99.24707804181816, 19.394272843816736],
    [-99.24684961401846, 19.39404441511772],
    [-99.24669732821911, 19.393633245078263],
    [-99.24697144157875, 19.392673845621516],
    [-99.2478699272553, 19.391851503743965],
    [-99.24849429687424, 19.39057230626696],
    [-99.24852475421397, 19.389947934849374],
    [-99.24832678285469, 19.387694109695474],
    [-99.24800698393511, 19.3869022251576],
    [-99.24761183801587, 19.386012579816736],
    [-99.2500512760455, 19.38404888314949],
    [-99.25544218291037, 19.3805996170787],
    [-99.25692696630642, 19.37959453206207],
    [-99.2576579370641, 19.378897826373645],
    [-99.26033054681727, 19.376567858320072],
    [-99.26098156784502, 19.37611100092198],
    [-99.26288894356986, 19.3750830740247],
    [-99.26333437867862, 19.374923173665593],
    [-99.26615546830021, 19.374534846406107],
    [-99.26668085313884, 19.37435210416635],
    [-99.26694354510846, 19.374077989907335],
    [-99.26724050214744, 19.373609712018663],
    [-99.26745750855713, 19.373472655338844],
    [-99.2677430442061, 19.373347019149662],
    [-99.26814279375492, 19.37346123394883],
    [-99.26865675720353, 19.373586869238693],
    [-99.26958189159097, 19.373472655338844],
    [-99.26993595468053, 19.3732213838598],
    [-99.27016438427887, 19.372901584040903],
    [-99.27017580476956, 19.372444728441508],
    [-99.26976463383073, 19.371485328984818],
    [-99.26967326271085, 19.371485328984818],
    [-99.2684625926745, 19.371782286023745],
    [-99.2682912718247, 19.371451064814835],
    [-99.26819990070481, 19.370765779617102],
    [-99.26837122155462, 19.370160445048555],
    [-99.26863391442356, 19.369600796039947],
    [-99.26879381388335, 19.36947516075014],
    [-99.26918214204221, 19.369075411201322],
    [-99.2683940652339, 19.368709925822486],
    [-99.26800573707504, 19.368721347212443],
    [-99.2677430442061, 19.368915510842214],
    [-99.26722908075743, 19.369338104070323],
    [-99.26681790981866, 19.370034809758693],
    [-99.26630394636999, 19.371051316165335],
    [-99.26617831108018, 19.371531015444077],
    [-99.2655958192916, 19.37204497799337],
    [-99.26539023337256, 19.372033556603412],
    [-99.26508185494362, 19.371736599564485],
    [-99.26542449664316, 19.371097000825955],
    [-99.26626968220006, 19.369121096761262],
    [-99.26671511730876, 19.367910426724848],
    [-99.26677222425872, 19.367293670766344],
    [-99.2667036959188, 19.36641422193884],
    [-99.2664410030498, 19.364975124102727],
    [-99.26650953228904, 19.364107096665236],
    [-99.26677222425872, 19.363536026266672],
    [-99.26586993175192, 19.36314769810781],
    [-99.26427093535534, 19.36258804909926],
    [-99.26272904411007, 19.36209692843056],
    [-99.2621237086422, 19.361731443051724],
    [-99.26149553129369, 19.361286007942965],
    [-99.26114146820419, 19.360863414714856],
    [-99.261015832015, 19.360417979606098],
    [-99.26044856934595, 19.35765399783378],
    [-99.26016303279766, 19.355902714738534],
    [-99.26000123037244, 19.355265018965497],
    [-99.26002026632221, 19.35511273406547],
    [-99.25991683799163, 19.354574023972077],
    [-99.2597112529719, 19.3537098042641],
    [-99.25947140288292, 19.35284558275748],
    [-99.2594295250525, 19.35260954129734],
    [-99.25931531115265, 19.352099383779603],
    [-99.2592658178632, 19.351947098879577],
    [-99.25920109635348, 19.3515283142803],
    [-99.25929627520293, 19.35077450074266],
    [-99.25934196076287, 19.350584143943138],
    [-99.25939525998325, 19.350428051313543],
    [-99.25930769569356, 19.350123479714853],
    [-99.25925439557386, 19.350062565934707],
    [-99.25915541079354, 19.349986423035034],
    [-99.25906403877434, 19.349963580255064],
    [-99.25894982487449, 19.349975001645078],
    [-99.25837875537525, 19.350077794154913],
    [-99.25833306891599, 19.35007017959515],
    [-99.2582455046263, 19.349986423035034],
    [-99.25819981906636, 19.34987982279563],
    [-99.25819601223611, 19.349754188405143],
    [-99.25828357562648, 19.34963235904621],
    [-99.25858814722517, 19.349449616806396],
    [-99.2589384043838, 19.349263066837125],
    [-99.25923155369321, 19.34906509637716],
    [-99.25939906771276, 19.348867125017875],
    [-99.25951328161261, 19.348638696318858],
    [-99.2597264811921, 19.3483569683994],
    [-99.25990541660167, 19.34828844005949],
    [-99.26035085171043, 19.348254175889565],
    [-99.2605526298999, 19.34821229715982],
    [-99.2610285223484, 19.347957218850638],
    [-99.2611198943676, 19.347831582661456],
    [-99.2611198943676, 19.34777447571156],
    [-99.26107040107809, 19.347732597881134],
    [-99.26096760766893, 19.347759248390673],
    [-99.26080390137889, 19.34788868961141],
    [-99.26056785901943, 19.348014325800534],
    [-99.26031278071025, 19.348067625920237],
    [-99.26013003757112, 19.34805239680071],
    [-99.260046281011, 19.348037168580504],
    [-99.25977216675204, 19.3479648334104],
    [-99.2596579528522, 19.347976253901038],
    [-99.25918586813327, 19.348174226159642],
    [-99.25903548619868, 19.348231333109595],
    [-99.25896410161198, 19.34818374278558],
    [-99.25895934329901, 19.34810760078517],
    [-99.25900693182439, 19.348036217097786],
    [-99.2597112529719, 19.347798270873568],
    [-99.25982546687175, 19.347750682348135],
    [-99.25995871672137, 19.347617431599247],
    [-99.26025376989554, 19.347522252749798],
    [-99.26043460916986, 19.347541288699574],
    [-99.26058689496921, 19.347517494436886],
    [-99.26066303696956, 19.347450869062413],
    [-99.26072490313175, 19.347312860899876],
    [-99.26078201008164, 19.347246236424724],
    [-99.26087718893109, 19.34718437026254],
    [-99.26118175963046, 19.34717485183802],
    [-99.26127217926762, 19.34711298567578],
    [-99.26138639316747, 19.347032083563874],
    [-99.26156723244179, 19.347046361200682],
    [-99.26167668802867, 19.347041601988394],
    [-99.26190987504066, 19.34697021830101],
    [-99.26204312489028, 19.34689883461357],
    [-99.26214306205264, 19.346760825551712],
    [-99.26230010616496, 19.34669420107656],
    [-99.26243811522681, 19.346665646702263],
    [-99.26257612428867, 19.34670371860176],
    [-99.26271413335053, 19.34679413823892],
    [-99.26282834725038, 19.34687504035088],
    [-99.26296635631223, 19.34688931708837],
    [-99.26311864121226, 19.34679889655189],
    [-99.26317098894992, 19.346737031289024],
    [-99.26322809589988, 19.34665137086415],
    [-99.26329947958726, 19.3463848711649],
    [-99.26333279317384, 19.346251621315332],
    [-99.26348507807387, 19.346118370566387],
    [-99.26364688139842, 19.3460755412533],
    [-99.26392289862281, 19.346056505303522],
    [-99.26406566599763, 19.346027951828546],
    [-99.2641465681096, 19.345951808928874],
    [-99.26416560405937, 19.34546163974295],
    [-99.26418939832206, 19.345342666630813],
    [-99.26433692490912, 19.345237971155484],
    [-99.26441782702108, 19.345237971155484],
    [-99.26455107687065, 19.34526652373114],
    [-99.26471763940748, 19.345314113155837],
    [-99.26476046872062, 19.34527604215566],
    [-99.26486516509527, 19.3451761049933],
    [-99.26488420104499, 19.345042855143674],
    [-99.26488420104499, 19.344957193819482],
    [-99.26487944183276, 19.344809668131745],
    [-99.26492227204517, 19.344714489282296],
    [-99.2650317276321, 19.344662140645312],
    [-99.26514118321899, 19.344633588069712],
    [-99.26538864696846, 19.34459551617016],
    [-99.26553141434329, 19.344524131583455],
    [-99.26563611071788, 19.344409917683606],
    [-99.26565990498057, 19.344295703783757],
    [-99.26575032461773, 19.344138659671444],
    [-99.26587405694215, 19.34406727598406],
    [-99.265988270842, 19.34405775755954],
    [-99.26661168987755, 19.344129142146244],
    [-99.26678301072735, 19.34407203519629],
    [-99.26681632341456, 19.344038721609763],
    [-99.26693053821373, 19.343800776284866],
    [-99.26724938475127, 19.34337723157404],
    [-99.26763961677489, 19.342725259962833],
    [-99.26815833943579, 19.342097081714996],
    [-99.26830586602284, 19.341987627027436],
    [-99.26839152734709, 19.341882930652787],
    [-99.26854857056003, 19.341840100440322],
    [-99.26872940983435, 19.341849617965522],
    [-99.26897211527086, 19.34188768986502],
    [-99.26920054307055, 19.34195907265314],
    [-99.26933379292018, 19.34205425240185],
    [-99.26947180198204, 19.342011422189444],
    [-99.26978589110593, 19.341797270227914],
    [-99.26987630984377, 19.341706850590754],
    [-99.26996197116802, 19.341587878377936],
    [-99.27029509534236, 19.34142607415407],
    [-99.27069865172137, 19.341167189014584],
    [-99.2709042367411, 19.341087239284718],
    [-99.27162378610882, 19.34081312502576],
    [-99.2720692221169, 19.340607540006033],
    [-99.27237759964646, 19.340516167986834],
    [-99.27286872031516, 19.340207789557894],
    [-99.27298293511433, 19.34015068260794],
    [-99.27331415632324, 19.340059312387382],
    [-99.27426213259133, 19.33952250525948],
    [-99.27470756770003, 19.339385447680343],
    [-99.27506163168891, 19.339248391000467],
    [-99.27543853755844, 19.33904280598074],
    [-99.2759410796171, 19.33886006284166],
    [-99.27726596355336, 19.338334678003037],
    [-99.27855658421896, 19.33772934433381],
    [-99.2792418694167, 19.337580865364714],
    [-99.27965304035547, 19.33763797231461],
    [-99.2798015184253, 19.337580865364714],
    [-99.2800642112943, 19.337432387294882],
    [-99.28044111716378, 19.337352436665697],
    [-99.28079518115266, 19.337363858055653],
    [-99.28116066563217, 19.337443807785576],
    [-99.28112640236156, 19.337112586576666],
    [-99.2806809672528, 19.336781366267076],
    [-99.28009847456491, 19.336427303177572],
    [-99.28001852483504, 19.33603897411939],
    [-99.28015558241418, 19.33529658287108],
    [-99.28040228443786, 19.335090996951976],
    [-99.28165864003415, 19.335576406925668],
    [-99.28257235303164, 19.33594760299951],
    [-99.28354317297902, 19.3366328881973],
    [-99.28448543855211, 19.336718548622173],
    [-99.28505650985, 19.336490119923155],
    [-99.28604160743419, 19.334068780749703],
    [-99.28751496944022, 19.33114489861822],
    [-99.2875378122202, 19.330870785258583],
    [-99.28740075464106, 19.330528142659716],
    [-99.28679542007256, 19.3298999653112],
    [-99.28665836339275, 19.32976290773206],
    [-99.28685252702246, 19.32978575141135],
    [-99.28783476925918, 19.33020834284082],
    [-99.28821167512865, 19.330459614319807],
    [-99.2883601540978, 19.33069946440878],
    [-99.28839441826773, 19.33121342785745],
    [-99.28823451790862, 19.331784498256013],
    [-99.28764060473009, 19.33300658878312],
    [-99.28764060473009, 19.333246438872095],
    [-99.28766344840938, 19.333360652771944],
    [-99.28781192557989, 19.333497710351082],
    [-99.28802893288889, 19.333520553131052],
    [-99.2882687820786, 19.333372075061277],
    [-99.28862284606748, 19.333063695733017],
    [-99.28958224462485, 19.331967241395148],
    [-99.29022945792309, 19.33063474289912],
    [-99.2912117001598, 19.32933270174283],
    [-99.29137921417936, 19.328784474124234],
    [-99.29137921417936, 19.328556046324536],
    [-99.29075484276177, 19.32705603290964],
    [-99.29079291466127, 19.32656871997051],
    [-99.29144774161995, 19.325434192833768],
    [-99.29167617121828, 19.324954492655763],
    [-99.29178276965905, 19.32440626593649],
    [-99.29160002831861, 19.323477323819475],
    [-99.29143251429906, 19.322753967621566],
    [-99.29117362826031, 19.32253315438163],
    [-99.29102134336028, 19.322495081582815],
    [-99.2905568723018, 19.32225142556291],
    [-99.29042742928237, 19.32203822598342],
    [-99.29046550118187, 19.32158898404441],
    [-99.29074722910133, 19.32130725612501],
    [-99.2912802276004, 19.321208270445368],
    [-99.29213302681768, 19.321033141866053],
    [-99.29261272609642, 19.3208656278465],
    [-99.2930238970352, 19.320599128147308],
    [-99.29332656476913, 19.32030217110838],
    [-99.29349788561888, 19.319913842949518],
    [-99.29356070416316, 19.319736811404766],
    [-99.29374915709786, 19.31886307327227],
    [-99.29397758489756, 19.318286292178698],
    [-99.29421172429159, 19.31794936027478],
    [-99.29419459220662, 19.317892253324885],
    [-99.2943887558364, 19.317515345656716],
    [-99.29455436689051, 19.317001383107367],
    [-99.29474281982522, 19.31691001198749],
    [-99.29490272018433, 19.316938564563145],
    [-99.29497124762491, 19.317001383107367],
    [-99.29512543728907, 19.317235521602072],
    [-99.29522251910396, 19.31738971126623],
    [-99.29536528737805, 19.317532478641],
    [-99.29549092176859, 19.317561032115975],
    [-99.29558229378779, 19.317532478641],
    [-99.29584498575747, 19.31736686758694],
    [-99.29609625723646, 19.31719554673714],
    [-99.29633610732543, 19.317178414652176],
    [-99.29643318914032, 19.31719554673714],
    [-99.2965017165809, 19.317269785772055],
    [-99.29656453512519, 19.317383999671904],
    [-99.29654740304017, 19.317429686131163],
    [-99.29639321427538, 19.31799504583472],
    [-99.29639892497039, 19.318074995564643],
    [-99.29638369585086, 19.31822537839855],
    [-99.29671682092453, 19.318606091098275],
    [-99.29688814177428, 19.318729823422643],
    [-99.2970213916239, 19.318805966322316],
    [-99.29719271337297, 19.31888210922199],
    [-99.29752583844663, 19.31893921617194],
    [-99.29775426624633, 19.318920180222165],
    [-99.29814449737063, 19.31916764397164],
    [-99.29835389011987, 19.319396071771337],
    [-99.29856328286917, 19.319672089895107],
    [-99.2986822559813, 19.319926691563637],
    [-99.29884167880039, 19.3206667050045],
    [-99.29899396459973, 19.321068834159405],
    [-99.29907962592398, 19.321183048059254],
    [-99.29931043332982, 19.321273466797095],
    [-99.29961500402919, 19.321504275102257],
    [-99.29980536082871, 19.321892126620412],
    [-99.29995050780963, 19.32206582797562],
    [-99.30007424013405, 19.32223476921928],
    [-99.30016941898344, 19.32231567133124],
    [-99.30033360191413, 19.32234422480616],
    [-99.30046447215761, 19.32230139369443],
    [-99.30056202971389, 19.32221097495659],
    [-99.30057392684523, 19.322087242632165],
    [-99.3005477529764, 19.321782671932795],
    [-99.30050254315779, 19.321649422083226],
    [-99.30049540523873, 19.321478101233424],
    [-99.30056202971389, 19.32132105622179],
    [-99.3006286550883, 19.32092130667303],
    [-99.30059058318881, 19.320626254398178],
    [-99.30059296279495, 19.32044779383068],
    [-99.30066196687625, 19.320221744737808],
    [-99.30080235464493, 19.320005214069397],
    [-99.30081187306945, 19.319974280988333],
    [-99.30105457760664, 19.31968636663254],
    [-99.30110454663748, 19.319443662095352],
    [-99.30110454663748, 19.319236648952256],
    [-99.30112358258725, 19.319139091395982],
    [-99.30116641279966, 19.318974907565973],
    [-99.30118544874944, 19.31888210922199],
    [-99.30125683243682, 19.318706029159955],
    [-99.3013496307808, 19.318615608623475],
    [-99.30158281869211, 19.318615608623475],
    [-99.30170179180419, 19.318582296835586],
    [-99.30177317459231, 19.31848949759228],
    [-99.30180648817884, 19.318287243661416],
    [-99.30174938122894, 19.318196824024255],
    [-99.3016446848543, 19.318123060730727],
    [-99.30132583741744, 19.317811351212924],
    [-99.30125921204296, 19.31770903534374],
    [-99.30119496627464, 19.317480605745402],
    [-99.30117355071877, 19.317366391845553],
    [-99.3011354797186, 19.317052302721663],
    [-99.30113357585378, 19.31691429455907],
    [-99.30071288828913, 19.31604436415614],
    [-99.30058915596476, 19.31549994336774],
    [-99.30007899934628, 19.31434257255171],
    [-99.30003331378634, 19.313999930852162],
    [-99.30007138478652, 19.31352784613324],
    [-99.30049778394556, 19.3124466191162],
    [-99.30100794056398, 19.31227910509665],
    [-99.30108408436297, 19.312202962196977],
    [-99.30125921204296, 19.31136539209922],
    [-99.30124398292344, 19.309690251004326],
    [-99.30133535494264, 19.309499894204805],
    [-99.30147241162246, 19.30943898042466],
    [-99.3017465249821, 19.30953035064522],
    [-99.30230998172027, 19.310246093182684],
    [-99.30306379525791, 19.31110650606047],
    [-99.30323130927746, 19.31115219162041],
    [-99.30339120873725, 19.311091277840262],
    [-99.30347496619669, 19.310977063041094],
    [-99.30428207895477, 19.30943898042466],
    [-99.30442675019435, 19.309378065745193],
    [-99.30471609267352, 19.309225779945848],
    [-99.30492929225301, 19.30918770894567],
    [-99.30504350705218, 19.309050652265853],
    [-99.30577447691053, 19.307390740290487],
    [-99.3059572200496, 19.307223226270935],
    [-99.30608666216966, 19.307169926151232],
    [-99.30636839098844, 19.30723083993138],
    [-99.30685570392757, 19.30781713944947],
    [-99.30699276060739, 19.307954196129288],
    [-99.30724403208637, 19.3079846525697],
    [-99.30738870332596, 19.30786282500941],
    [-99.30738108876619, 19.307710539210063],
    [-99.30738870332596, 19.30690342555272],
    [-99.30754860278574, 19.30652271195362],
    [-99.30776180326455, 19.305883113215145],
    [-99.30795977372452, 19.305578541616455],
    [-99.308218658864, 19.305418643055987],
    [-99.30880495928142, 19.305083614117564],
    [-99.30907907174173, 19.30509884323709],
    [-99.30929227222055, 19.305228286256465],
    [-99.30945217168033, 19.305487171395896],
    [-99.30943694256081, 19.305578541616455],
    [-99.30938364334042, 19.305746055636007],
    [-99.30935318600069, 19.30591356965556],
    [-99.30934557234025, 19.30638565617312],
    [-99.30942171523992, 19.30678921165287],
    [-99.3094978581396, 19.306964340232184],
    [-99.31008415675836, 19.30756586797048],
    [-99.31019075699783, 19.307596325310215],
    [-99.3103506555583, 19.30751256785078],
    [-99.3104572557977, 19.30739835395093],
    [-99.31061715615681, 19.30693388289245],
    [-99.31068568539604, 19.306796826212633],
    [-99.31083797029606, 19.306728297872723],
    [-99.31127198401481, 19.30688819823183],
    [-99.31140904069463, 19.3069110410118],
    [-99.31160701205391, 19.306796826212633],
    [-99.31195726921254, 19.306393269833563],
    [-99.31202579665313, 19.306027785354047],
    [-99.31222376801247, 19.305555699735805],
    [-99.31228468179262, 19.305228286256465],
    [-99.31214001055304, 19.304969400217715],
    [-99.31205625399286, 19.304672444078108],
    [-99.31197249743275, 19.304352644259154],
    [-99.31208671133265, 19.304169901120076],
    [-99.31293189599018, 19.304169901120076],
    [-99.31325931036884, 19.30394147332038],
    [-99.31364002306856, 19.303553145161573],
    [-99.31389129364823, 19.303096288662857],
    [-99.31389890910731, 19.302456689924327],
    [-99.31392175188728, 19.301603890707042],
    [-99.31395982288745, 19.301451604907697],
    [-99.31411972324662, 19.30139069112755],
    [-99.31434053738587, 19.301375462008025],
    [-99.31461465074551, 19.30143637668749],
    [-99.31471363642515, 19.30145921856814],
    [-99.31515526380434, 19.301276477227702],
    [-99.31533039238366, 19.301002362968745],
    [-99.31568826320273, 19.300621649369646],
    [-99.31600044936124, 19.30032469233072],
    [-99.31641923396046, 19.300058192631525],
    [-99.3164268476209, 19.299989664291616],
    [-99.31640400484093, 19.299875450391767],
    [-99.31627456272088, 19.29972316459242],
    [-99.31594714924148, 19.299372908333112],
    [-99.31589384912178, 19.299144479634094],
    [-99.3159776056819, 19.29890082271487],
    [-99.31611466326109, 19.298641937575383],
    [-99.31622126260118, 19.298337366876012],
    [-99.31623649082138, 19.29812416729652],
    [-99.31645730496064, 19.29741603931882],
    [-99.3167847193393, 19.29699725382028],
    [-99.31715781837858, 19.295832270243125],
    [-99.31715781837858, 19.295086071265246],
    [-99.31695223335885, 19.29464444298668],
    [-99.31710451915819, 19.294256114827874],
    [-99.31702076169876, 19.29392108678877],
    [-99.3171349755986, 19.29342615928988],
    [-99.31705883269893, 19.292655213667217],
    [-99.31668763662509, 19.291741500669787],
    [-99.31654486925027, 19.291084768946973],
    [-99.31643065535042, 19.290770680722403],
    [-99.31574537015268, 19.289856967724916],
    [-99.3159737988517, 19.289028915152358],
    [-99.31617367317642, 19.28768689913113],
    [-99.31660197620022, 19.28720148915744],
    [-99.3166305296752, 19.286030793986015],
    [-99.31623078012638, 19.284346136265242],
    [-99.31585958495185, 19.2837750649673],
    [-99.31568826320273, 19.282118959822185],
    [-99.3161451197015, 19.28066272990111],
    [-99.3162022266514, 19.27983467822787],
    [-99.31674474357504, 19.279320713879883],
    [-99.31694461879908, 19.27815001870846],
    [-99.31683040489924, 19.277664608734767],
    [-99.31717304659878, 19.277064984861227],
    [-99.31711593964889, 19.276065612338186],
    [-99.3173443683479, 19.27483781021681],
    [-99.31885770521887, 19.273153150697397],
    [-99.32365469890522, 19.265186715894288],
    [-99.32351193063107, 19.25031032576095],
    [-99.32385457412926, 19.245399118174817],
    [-99.32431142972865, 19.23472009695496],
    [-99.32431142972865, 19.23271591190985],
    [-99.32689741138637, 19.23271591190985],
    [-99.33078069207522, 19.238083975994755],
    [-99.34231631934261, 19.241224863636603],
    [-99.34214499669423, 19.247620854618788],
    [-99.34128839244534, 19.25241784920445],
    [-99.33986071509986, 19.25955623233432],
    [-99.33751932475701, 19.26406769037169],
    [-99.33911832295223, 19.26777964931142],
    [-99.34077442809735, 19.26777964931142],
    [-99.34248764019242, 19.26840782665994],
    [-99.34471481483678, 19.269378646607322],
    [-99.34619959913215, 19.271605822151002],
    [-99.34619959913215, 19.27200557169982],
    [-99.3475130616784, 19.273090606446374],
    [-99.34831255987672, 19.27411853334371],
    [-99.36190404183805, 19.27583174543878],
    [-99.36504493037921, 19.277830492283442],
    [-99.35362351701167, 19.291993043744014],
    [-99.35487987260802, 19.293592041939235],
    [-99.35396615961054, 19.293592041939235],
    [-99.35276691096414, 19.293991790588734],
    [-99.3515105562671, 19.294562861886618],
    [-99.35128212756808, 19.295019719284653],
    [-99.3530524466131, 19.296218967031734],
    [-99.35343316021215, 19.29755146462844],
    [-99.35019709372085, 19.296885216279748],
    [-99.35647887080319, 19.301910637765786],
    [-99.35651555325012, 19.303451313127653],
    [-99.35651725836476, 19.30352290995438],
    [-99.35659308470304, 19.30670763055275],
    [-99.35525046433742, 19.308116211693857],
    [-99.34177221511561, 19.32225661465111],
    [-99.33380102110021, 19.33058472890218],
    [-99.333563074876, 19.331179593563434],
    [-99.33277785341517, 19.332464502634764],
    [-99.33227816580467, 19.333582850068524],
    [-99.33192124736763, 19.334891553402542],
    [-99.33166902440593, 19.336600006285323],
    [-99.33172613135582, 19.337780218981948],
    [-99.33153577365698, 19.33844646822996],
    [-99.33119313195743, 19.338789110828827],
    [-99.33115506005794, 19.339798001776387],
    [-99.33067916760945, 19.340102573375134],
    [-99.3302984540104, 19.341016286372565],
    [-99.32974641866224, 19.34156832082141],
    [-99.32949895491282, 19.342310712969095],
    [-99.32915631321328, 19.342900819317435],
    [-99.32892788541352, 19.343605139565568],
    [-99.32875656366446, 19.34389067521454],
    [-99.32871849176496, 19.344290423864038],
    [-99.32826163616556, 19.345166065861292],
    [-99.3288898126147, 19.345641958309784],
    [-99.32883270566481, 19.34607977885878],
    [-99.32847102801549, 19.346784100006232],
    [-99.32854717091516, 19.34760263415427],
    [-99.32871849176496, 19.347926240803417],
    [-99.32831398390317, 19.34949668462434],
    [-99.3288612600391, 19.350377085833884],
    [-99.32866995085749, 19.351364086383512],
    [-99.32882223665683, 19.352110285361448],
    [-99.32873086463763, 19.352475769840964],
    [-99.32851766595746, 19.35314582591917],
    [-99.3281217232389, 19.353313340838042],
    [-99.32771055230012, 19.35363313975762],
    [-99.32766486674018, 19.354059539815978],
    [-99.32740598070143, 19.35413568181633],
    [-99.32638566926317, 19.353694054437085],
    [-99.32583744074526, 19.354638223874986],
    [-99.32574606872606, 19.35497325281341],
    [-99.32536535602634, 19.35549102309227],
    [-99.32506078532697, 19.35570422267176],
    [-99.32506078532697, 19.356024023390034],
    [-99.32466484170902, 19.356450421649697],
    [-99.32374922574616, 19.35797518081],
    [-99.32317815534753, 19.358379688671732],
    [-99.32222637134993, 19.358665224320703],
    [-99.32146494325247, 19.35849866178387],
    [-99.32082248916652, 19.35821312703422],
    [-99.3201324447565, 19.357737233686407],
    [-99.31908548190944, 19.35759446721096],
    [-99.31860959036027, 19.357951385647993],
    [-99.31815749217446, 19.358165536710203],
    [-99.32070351605438, 19.360473615265164],
    [-99.31956137435793, 19.363614502907012],
    [-99.31810508238362, 19.364117377714877],
    [-99.31801497301257, 19.36499594790473],
    [-99.31758695057727, 19.36576188070626],
    [-99.31682101777574, 19.366347593866408],
    [-99.31537926244295, 19.365919573229746],
    [-99.31454574738831, 19.36724869207353],
    [-99.31445712729453, 19.367495753826006],
    [-99.31380234080535, 19.369321216600895],
    [-99.31310399025693, 19.370470115803244],
    [-99.3107611358177, 19.370425060668083],
    [-99.30931937958565, 19.371596487887643],
    [-99.30778751398253, 19.37157396076975],
    [-99.30612048297388, 19.373623958179166],
    [-99.30506169404191, 19.37684538190888],
    [-99.3035298284388, 19.37785911660501],
    [-99.30134466562379, 19.377070655786213],
    [-99.30193037878394, 19.375764064959696],
    [-99.30156994040038, 19.37499813215811],
    [-99.3011419188644, 19.372159673929843],
    [-99.30098422724024, 19.371956927170515],
    [-99.30087158985197, 19.37058275319157],
    [-99.30098422724024, 19.370109677419748],
    [-99.30123114420189, 19.369716810382556],
    [-99.29900777638773, 19.36749344076975],
    [-99.29847477698934, 19.368726953586076],
    [-99.29807883517009, 19.36922949564473],
    [-99.29753060665212, 19.369412238783866],
    [-99.29714989305307, 19.369336095884194],
    [-99.29558135219759, 19.36910766808444],
    [-99.2947285529803, 19.369899551722995],
    [-99.29446966784087, 19.369945238182254],
    [-99.29389098288254, 19.37014320864222],
    [-99.29376915532225, 19.370463009360435],
    [-99.29340366994336, 19.37120920833837],
    [-99.29328184058443, 19.371894491737464],
    [-99.29204832866742, 19.373325975913133],
    [-99.29166761506832, 19.373478261712478],
    [-99.29118030122987, 19.373493489932684],
    [-99.2911041583302, 19.373980803771133],
    [-99.29075390207089, 19.37434628914997],
    [-99.29066253005169, 19.375062030788115],
    [-99.289733588834, 19.374985887888442],
    [-99.28955084569492, 19.37519908836731],
    [-99.2886219053766, 19.37510771724743],
    [-99.28810413419842, 19.37571685864617],
    [-99.28769296325959, 19.376630571643602],
    [-99.28655082156314, 19.37644021484408],
    [-99.28567042125292, 19.37644021484408],
    [-99.28571801067761, 19.37765374022797],
    [-99.2850993508543, 19.378010658665005],
    [-99.28507555569229, 19.379033827249373],
    [-99.28474243241726, 19.379224184048894],
    [-99.28464725266855, 19.37965248707269],
    [-99.28431412939352, 19.379819048710203],
    [-99.28386679042, 19.37967152302241],
    [-99.28375257562084, 19.38007127167191],
    [-99.28326716564715, 19.3803853607958],
    [-99.28283886262335, 19.38147039464303],
    [-99.28072590097952, 19.381527501592984],
    [-99.27886801764487, 19.382958985768653],
    [-99.27874619008458, 19.383568128066713],
    [-99.2760964222121, 19.385593525420916],
    [-99.27606596487237, 19.385197582702347],
    [-99.2738660792561, 19.386896229377555],
    [-99.27365985391907, 19.387055466036998],
    [-99.27361416835913, 19.387207751836343],
    [-99.27323345476009, 19.387603693655592],
    [-99.27298979784086, 19.388593549552695],
    [-99.27282228382131, 19.389400663210097],
    [-99.27242634110274, 19.389705233909467],
    [-99.27183242792415, 19.389750920368726],
    [-99.27061414422735, 19.39004026194857],
    [-99.26960906010999, 19.39034483264794],
    [-99.26951768809079, 19.39055803312675],
    [-99.2696395165504, 19.391014888726204],
    [-99.26944154519111, 19.391441288784506],
    [-99.26907605981228, 19.391608802804058],
    [-99.26829940439399, 19.39217225864286],
    [-99.26810143303464, 19.392644344261157],
    [-99.26796437635483, 19.394091055757656],
    [-99.26689837755805, 19.395339797693566],
    [-99.26645675017886, 19.396040311111506],
    [-99.26609126390065, 19.39741087970839],
    [-99.26581714964169, 19.398111394025648],
    [-99.26564963562214, 19.398339821825346],
    [-99.26508617978334, 19.398979420563876],
    [-99.26496435222305, 19.398994649683402],
    [-99.26465978062436, 19.39870530720424],
    [-99.26403541010603, 19.39870530720424],
    [-99.2640201809865, 19.39908602080328],
    [-99.26412678122591, 19.39926876394236],
    [-99.26391358164642, 19.39943627796191],
    [-99.2632435246689, 19.399542877301997],
    [-99.2626800688301, 19.399679933981815],
    [-99.26217752677138, 19.399710392220868],
    [-99.26187295607201, 19.399375363282445],
    [-99.26175112671308, 19.39926876394236],
    [-99.26129427111368, 19.399329677722505],
    [-99.26116673195907, 19.399639007634164],
    [-99.26088119720947, 19.39997213180851],
    [-99.25985802772578, 19.400543203106395],
    [-99.25966767092626, 19.400733559905916],
    [-99.25907280626495, 19.401471192841313],
    [-99.25923936790247, 19.401756727590964],
    [-99.25883486004074, 19.40370788591025],
    [-99.25869209176659, 19.404064805246605],
    [-99.25814481563071, 19.404802438182003],
    [-99.25769271924355, 19.404850026707436],
    [-99.25771651260692, 19.40430275057156],
    [-99.25800204915521, 19.404088600408613],
    [-99.25823999537943, 19.403065431824245],
    [-99.25828758390486, 19.40251815568837],
    [-99.25695223096068, 19.40042327761222],
    [-99.25673903138113, 19.400606020751297],
    [-99.25603851706387, 19.40254004698562],
    [-99.25606897530292, 19.403545131102987],
    [-99.25579486104397, 19.403560359323194]
  ],
  [
    // ID Magdalena Contreras: V1-C-521
    [-99.20752566397817, 19.33789861472934],
    [-99.20864496199539, 19.33601408178447],
    [-99.20708022886942, 19.336550888912427],
    [-99.20665763744, 19.33620824631356],
    [-99.20762987561824, 19.335476763841655],
    [-99.20845221659647, 19.334532594403754],
    [-99.20970095763306, 19.33264425372937],
    [-99.2108278711093, 19.330451342355616],
    [-99.21242686930452, 19.327283804204228],
    [-99.2134471816421, 19.326019834048168],
    [-99.21527460763701, 19.32471017923143],
    [-99.21730000499122, 19.323309152395495],
    [-99.22040888935874, 19.321092504315686],
    [-99.22069597184156, 19.320887813222043],
    [-99.22128988502016, 19.320050242224966],
    [-99.22150308459965, 19.31909084366754],
    [-99.22061031141669, 19.31412823982646],
    [-99.22024482603786, 19.312951833960028],
    [-99.21994110609711, 19.312276899958988],
    [-99.22053699418689, 19.311144712858265],
    [-99.22387911772705, 19.31088169173671],
    [-99.22491100433933, 19.310670548906785],
    [-99.22513592118577, 19.30996696520333],
    [-99.2253948063252, 19.309814679403985],
    [-99.22675014670187, 19.30879436706641],
    [-99.22778568815892, 19.307865424949455],
    [-99.22758771679963, 19.30710399685205],
    [-99.22789228839838, 19.30686034083209],
    [-99.2287907731756, 19.30651008367346],
    [-99.22938468635414, 19.30651008367346],
    [-99.22979585729297, 19.306190283854562],
    [-99.2300395142122, 19.30593139871513],
    [-99.23095322720962, 19.305611598896235],
    [-99.23194308310678, 19.30506337217696],
    [-99.23203445422666, 19.30390600226025],
    [-99.23226288202636, 19.303799402020843],
    [-99.23236948226577, 19.30299228926276],
    [-99.23252176806511, 19.303007516583648],
    [-99.23259791006546, 19.30264203210413],
    [-99.23296339634362, 19.301804462006373],
    [-99.23218674002601, 19.30146943396727],
    [-99.2329481672241, 19.300951662789032],
    [-99.23325273792346, 19.300845063448946],
    [-99.23340502372281, 19.30082983522874],
    [-99.2332831952632, 19.300144550031007],
    [-99.23273496674528, 19.299992264231662],
    [-99.23267405296514, 19.29982475021211],
    [-99.23284156698469, 19.299642007972352],
    [-99.23276542408502, 19.299109007674588],
    [-99.23270451030487, 19.298469408936114],
    [-99.23243039604591, 19.297814581977434],
    [-99.23306999478439, 19.296916097200153],
    [-99.23308522390391, 19.296809496960748],
    [-99.23348116572316, 19.296428784261025],
    [-99.23392279400173, 19.296200354662687],
    [-99.23449005757004, 19.295728269943766],
    [-99.23468041526894, 19.29568068141839],
    [-99.23501353944323, 19.295347556344723],
    [-99.23553702131642, 19.294966842745623],
    [-99.23601291286559, 19.29518099380789],
    [-99.23613188597773, 19.294966842745623],
    [-99.23587014459144, 19.29460992430859],
    [-99.23596532434021, 19.294419566609747],
    [-99.23691710833782, 19.294300594396987],
    [-99.23748817873644, 19.294253004072914],
    [-99.2385827310082, 19.294705102258717],
    [-99.23955831016787, 19.294490951196508],
    [-99.24036732589133, 19.294062648172712],
    [-99.24079562891512, 19.294229209810226],
    [-99.24147339488121, 19.293975474188812],
    [-99.24159522424014, 19.29359476058977],
    [-99.24191502315978, 19.293168361430787],
    [-99.24151908134047, 19.292863789832097],
    [-99.24229573675882, 19.29289424717183],
    [-99.2426155356784, 19.29242216155359],
    [-99.24299625017676, 19.291447534775955],
    [-99.242813507937, 19.289285080741934],
    [-99.24240233699823, 19.289269851622407],
    [-99.24170182268091, 19.288767309563752],
    [-99.24100131016229, 19.28800588326493],
    [-99.24101653928182, 19.287472882967222],
    [-99.240803338803, 19.28730536894767],
    [-99.24082998931254, 19.286924655348628],
    [-99.24095181687284, 19.28678759866881],
    [-99.2413477595914, 19.286680999328723],
    [-99.24159141561131, 19.28639165595024],
    [-99.24185030165006, 19.285691143431563],
    [-99.24267264442699, 19.284335802155567],
    [-99.24280970110681, 19.284335802155567],
    [-99.24302289978698, 19.284183516356222],
    [-99.24290107222669, 19.283787573637653],
    [-99.2423223872683, 19.28336117537799],
    [-99.24206350212887, 19.283285031579],
    [-99.24197213010967, 19.28310228933924],
    [-99.2420025874494, 19.282919547099482],
    [-99.24271832908761, 19.282554061720646],
    [-99.24323610026579, 19.28237131858151],
    [-99.24358635742442, 19.282173348121546],
    [-99.24361681386483, 19.281929691202322],
    [-99.24346452806549, 19.28176217718277],
    [-99.24332747138567, 19.28145760558408],
    [-99.24337315694561, 19.28115303488471],
    [-99.24387569900426, 19.28054389258665],
    [-99.24430209816325, 19.28025455010743],
    [-99.2449569260213, 19.280178408107076],
    [-99.24481986934148, 19.279401751789464],
    [-99.24488078312163, 19.279051494630835],
    [-99.24532241140014, 19.277376354435262],
    [-99.24539855429981, 19.276843355036874],
    [-99.24524626939979, 19.276538784337504],
    [-99.24501783980145, 19.276371270317895],
    [-99.24443915484306, 19.276203756298344],
    [-99.2441345841437, 19.27600578493906],
    [-99.24399752656456, 19.275853499139714],
    [-99.24381478522412, 19.275929642039387],
    [-99.24347975718501, 19.275625071340016],
    [-99.24354067096516, 19.275229128621447],
    [-99.24389092812379, 19.27426973006402],
    [-99.24411174226304, 19.27398800214462],
    [-99.24454956191272, 19.272902968297387],
    [-99.24432113411302, 19.272446110899352],
    [-99.24409270631332, 19.272446110899352],
    [-99.24376909876486, 19.271722754701443],
    [-99.24371199181496, 19.271227827202495],
    [-99.24357874196534, 19.27025700725511],
    [-99.24338838516582, 19.27006664955627],
    [-99.24344549211571, 19.269724007856723],
    [-99.24373102776468, 19.26935281178288],
    [-99.2449017229361, 19.268667526585148],
    [-99.2453300259599, 19.268125009661503],
    [-99.2457868815593, 19.26792513533678],
    [-99.24612952505748, 19.267411171888114],
    [-99.24592964983344, 19.266811548014573],
    [-99.24595820330842, 19.266383244990834],
    [-99.24638650633216, 19.26584072716787],
    [-99.2469861302057, 19.265612299368172],
    [-99.24701468368067, 19.264555818096596],
    [-99.24558700723458, 19.263442230774388],
    [-99.24552990028462, 19.262985374275672],
    [-99.24567266765945, 19.261700465204342],
    [-99.24627229243231, 19.260758198731935],
    [-99.24732877280456, 19.260387002658092],
    [-99.2469290232558, 19.25978737878455],
    [-99.24607241720827, 19.25910209358682],
    [-99.2453871329098, 19.258845112312144],
    [-99.24487316856187, 19.259073540111842],
    [-99.24447341991237, 19.259444736185685],
    [-99.24407367036355, 19.25947328966066],
    [-99.24390234861448, 19.259387629235732],
    [-99.24390234861448, 19.258959326211993],
    [-99.24433065163822, 19.258274041014204],
    [-99.2449017229361, 19.257902844940418],
    [-99.24541568638477, 19.257360328016773],
    [-99.24535857943488, 19.256932024993034],
    [-99.24475895466202, 19.256332401119494],
    [-99.2453014715856, 19.25519026032231],
    [-99.24484461598621, 19.254590636448768],
    [-99.24450197338734, 19.25296308387925],
    [-99.24521581116073, 19.25127842615848],
    [-99.24515870421078, 19.250478927060897],
    [-99.2457868815593, 19.249765089287507],
    [-99.24607241720827, 19.24956521406341],
    [-99.24661493503118, 19.24945100016356],
    [-99.24690046978083, 19.249051250614798],
    [-99.24750928112837, 19.248935830724065],
    [-99.24756638807833, 19.248107779050827],
    [-99.24762349502822, 19.247451047328013],
    [-99.24808035242631, 19.246794315605257],
    [-99.24850865455073, 19.246908530404426],
    [-99.24965079624724, 19.246423120430734],
    [-99.24965079624724, 19.24608047783181],
    [-99.24985067057196, 19.24576638870792],
    [-99.25036463402063, 19.245652174808072],
    [-99.25047884792048, 19.245223871784333],
    [-99.25010765184663, 19.244709908335665],
    [-99.25087859836856, 19.243938962713003],
    [-99.2518208639417, 19.2425683932168],
    [-99.25184941831594, 19.242111536718085],
    [-99.25179231136605, 19.24194021586834],
    [-99.25136400834225, 19.241597573269416],
    [-99.25110702616831, 19.241312037620503],
    [-99.25093570531851, 19.240483985047945],
    [-99.25156388266703, 19.240084236398445],
    [-99.2518208639417, 19.239427504675632],
    [-99.25193507784155, 19.23874222037722],
    [-99.25287734521328, 19.237571525205794],
    [-99.25267746998924, 19.23631516960944],
    [-99.25293445216317, 19.23554422398678],
    [-99.25333420081267, 19.234887493163342],
    [-99.2540480403847, 19.234459190139546],
    [-99.25420032528473, 19.234078475641184],
    [-99.25517114523211, 19.233850047841486],
    [-99.2560848582296, 19.23259369314445],
    [-99.2573412138259, 19.232536586194556],
    [-99.2573412138259, 19.23196551489667],
    [-99.25899731897107, 19.230537837551196],
    [-99.2603678875679, 19.2296812333023],
    [-99.26202399271307, 19.229338589804115],
    [-99.26333745615864, 19.22876751940555],
    [-99.26516488215356, 19.227225629059603],
    [-99.26624991600079, 19.226997200360586],
    [-99.26824866284545, 19.225626630864383],
    [-99.26939080364264, 19.224427383117302],
    [-99.27064716013831, 19.22437027616735],
    [-99.27081848098805, 19.22385631181936],
    [-99.27213194263499, 19.22305681272178],
    [-99.27281722783277, 19.221971778874547],
    [-99.2741877982283, 19.221286493676814],
    [-99.2739593686299, 19.21963038943096],
    [-99.2741877982283, 19.21843114078456],
    [-99.27470176077759, 19.217574534737025],
    [-99.27647207982261, 19.216432393939897],
    [-99.27630075897281, 19.21591842959191],
    [-99.27727157892019, 19.214833395744677],
    [-99.27789975716803, 19.21449075314581],
    [-99.27881347016546, 19.214148111446264],
    [-99.2794416484133, 19.21409100359699],
    [-99.28058378921048, 19.213748361897444],
    [-99.28109775265915, 19.213862575797293],
    [-99.2824683221553, 19.213063076699655],
    [-99.28326782125293, 19.21300596974976],
    [-99.28378178470155, 19.213634147098276],
    [-99.28480971159888, 19.213748361897444],
    [-99.28555210374657, 19.21329150539873],
    [-99.28600896024528, 19.213462826248474],
    [-99.28743663669138, 19.213120183649607],
    [-99.28817902793975, 19.213348612348625],
    [-99.28897852703733, 19.213748361897444],
    [-99.28966381223512, 19.213748361897444],
    [-99.29160545212989, 19.214719181844828],
    [-99.29257627207727, 19.21380546884734],
    [-99.2932044503251, 19.21391968274719],
    [-99.29423237722239, 19.215118931393647],
    [-99.29508898326992, 19.215347359193345],
    [-99.29554583976864, 19.216432393939897],
    [-99.29674508841504, 19.217745855586827],
    [-99.29794433616217, 19.218145606034966],
    [-99.29874383525976, 19.21791717733589],
    [-99.30000019085611, 19.217688748636874],
    [-99.30114233165324, 19.218202712984862],
    [-99.30159918905127, 19.218259819934815],
    [-99.30182761685103, 19.218374033834664],
    [-99.30565378969061, 19.222257313624198],
    [-99.3061677540386, 19.222371528423366],
    [-99.30770964438454, 19.223113919671732],
    [-99.3087375721812, 19.223627884019663],
    [-99.30947996342951, 19.22477002481685],
    [-99.31073631902586, 19.225283989164836],
    [-99.3118213528731, 19.226026380413202],
    [-99.31250663807083, 19.226026380413202],
    [-99.31307770757013, 19.225797951714128],
    [-99.31553404925694, 19.227232261559664],
    [-99.31530467716908, 19.229232380769815],
    [-99.3213580255524, 19.23271591190985],
    [-99.32226631923521, 19.23271591190985],
    [-99.32256327627414, 19.23378101588122],
    [-99.32255185488418, 19.233952336731022],
    [-99.32266606878403, 19.2341350798701],
    [-99.32276886219319, 19.235151586276743],
    [-99.32272317573393, 19.235654128335398],
    [-99.3230087113829, 19.235951085374325],
    [-99.32295160443294, 19.236487890703643],
    [-99.32284881102379, 19.236746775843073],
    [-99.32272698256418, 19.237508203940536],
    [-99.32278028268388, 19.23763764695991],
    [-99.32284119736335, 19.23775186085976],
    [-99.32285642558355, 19.237957445879488],
    [-99.32287926926284, 19.238071659779337],
    [-99.32296302582296, 19.238155417238772],
    [-99.3231000834021, 19.238201102798712],
    [-99.32323714008191, 19.238300087579034],
    [-99.32331328208227, 19.238536130837815],
    [-99.32326759742165, 19.23868841573784],
    [-99.32316861084269, 19.239099586676616],
    [-99.32316861084269, 19.239259487035724],
    [-99.32271175524329, 19.240256956593328],
    [-99.32264322600406, 19.240386399612703],
    [-99.32195794080627, 19.241086913030642],
    [-99.32083864278911, 19.24223666928691],
    [-99.32017620127061, 19.243059010265142],
    [-99.32003153003103, 19.243180838724754],
    [-99.31978025855204, 19.24331789630395],
    [-99.31942238773297, 19.243439723864242],
    [-99.31924725915366, 19.243454952983768],
    [-99.31884370277464, 19.243226525184014],
    [-99.31876755987497, 19.24319606694496],
    [-99.31850867473554, 19.24334073908392],
    [-99.31837923171611, 19.243500637644388],
    [-99.31828405286672, 19.243721451783642],
    [-99.31788430421722, 19.244175453834202],
    [-99.31770156107814, 19.24438103885393],
    [-99.3176358880857, 19.24450096434805],
    [-99.31757878113581, 19.244715115410315],
    [-99.31751596259159, 19.24502349293988],
    [-99.31750454210089, 19.245306173241374],
    [-99.31779578844487, 19.24566880327268],
    [-99.31773011455311, 19.245928639894885],
    [-99.31758449183081, 19.246020011914084],
    [-99.31756450439832, 19.246082829558986],
    [-99.31757878113581, 19.24616848998386],
    [-99.31771012801994, 19.246396917783557],
    [-99.31784432935228, 19.247073636938865],
    [-99.31784432935228, 19.247133599236292],
    [-99.31780149913982, 19.247287788900394],
    [-99.31777294476558, 19.247364883282785],
    [-99.3175245304327, 19.247610443167446],
    [-99.31741317098101, 19.247827449577187],
    [-99.31729324638616, 19.248047313133043],
    [-99.31711335859461, 19.248635514717307],
    [-99.3169905777529, 19.24915233441277],
    [-99.31701056608472, 19.249709128073846],
    [-99.3170448302547, 19.250048915325237],
    [-99.31707338372962, 19.250311608194238],
    [-99.31678213828502, 19.25078845212539],
    [-99.3167078992501, 19.250785595878597],
    [-99.31662794862092, 19.250739911217977],
    [-99.31658511840845, 19.25080272796356],
    [-99.31644235103363, 19.251036867357584],
    [-99.31638809943121, 19.251051144095072],
    [-99.31633670317626, 19.25103401201011],
    [-99.31618251441148, 19.250859834913513],
    [-99.31613397260469, 19.250845559075344],
    [-99.31603118009485, 19.250836993032863],
    [-99.31596265085562, 19.25084841442282],
    [-99.31591410994815, 19.250928364152742],
    [-99.315916966195, 19.250985471102638],
    [-99.31595694105994, 19.251296703979733],
    [-99.31593124203317, 19.25153369872129],
    [-99.31590840015252, 19.25165647866362],
    [-99.3159712168981, 19.251827800412684],
    [-99.31606829871299, 19.25194772500754],
    [-99.31607972100227, 19.25201625334745],
    [-99.31605973267051, 19.25208763703489],
    [-99.31597978294059, 19.252159020722274],
    [-99.3158827011257, 19.252338907614558],
    [-99.31585700299826, 19.252458833108733],
    [-99.31595123036493, 19.252621587915996],
    [-99.31594266432245, 19.252798620360068],
    [-99.31587699133007, 19.252918544954923],
    [-99.31571994631844, 19.25301562676981],
    [-99.31549722921375, 19.253312583808736],
    [-99.31534304044891, 19.2537465984268],
    [-99.31526023357287, 19.253957894141536],
    [-99.3151945605805, 19.254349076748554],
    [-99.31500039695072, 19.254640323092474],
    [-99.31488047235587, 19.254840198316572],
    [-99.31477196915102, 19.25497439874954],
    [-99.31478624588851, 19.255228525576058],
    [-99.31487476166086, 19.255351306417708],
    [-99.31501181924006, 19.25548265240252],
    [-99.31515173126735, 19.25563684116736],
    [-99.3152716558622, 19.25578246388966],
    [-99.31543441066947, 19.25590524473131],
    [-99.31548009712873, 19.25602802467364],
    [-99.31546867483945, 19.25614509392102],
    [-99.31536017163455, 19.25636781192503],
    [-99.3152459577347, 19.256424918874984],
    [-99.31501181924006, 19.25649059186736],
    [-99.31476911380355, 19.25651343464733],
    [-99.31460635899623, 19.256724731261386],
    [-99.31438364099222, 19.25681324703379],
    [-99.31421232014242, 19.25682752377128],
    [-99.31408668395329, 19.256816102381265],
    [-99.31392392914597, 19.256753283837043],
    [-99.31375831899118, 19.256653346674682],
    [-99.31353274563969, 19.25665049222647],
    [-99.31279606508627, 19.256707599176423],
    [-99.3125505043023, 19.256944593018602],
    [-99.31227068024765, 19.257084505045896],
    [-99.31120372906878, 19.257073560296647],
    [-99.31075639099464, 19.257183014984207],
    [-99.31020435564648, 19.257275814227512],
    [-99.30973560201636, 19.257592282058226],
    [-99.30926922799244, 19.2578183311511],
    [-99.30877905880646, 19.258101487193926],
    [-99.30791531394055, 19.25796347813207],
    [-99.30689928417456, 19.25777787964546],
    [-99.30622827571432, 19.25774932706986],
    [-99.3051089776971, 19.257992983989084],
    [-99.30384500844036, 19.258396540368096],
    [-99.3035175940617, 19.258678268287497],
    [-99.30303789478296, 19.258678268287497],
    [-99.30236783870475, 19.258937154326247],
    [-99.30215463912526, 19.25936355258591],
    [-99.3019185967658, 19.25951583928463],
    [-99.30172062540652, 19.26000315222376],
    [-99.30147696938661, 19.26052092340194],
    [-99.30101249832808, 19.260878794221014],
    [-99.30087544074894, 19.26103107912104],
    [-99.30058609826978, 19.26109960836027],
    [-99.30022822655138, 19.26093970800116],
    [-99.29978660007151, 19.260886407881458],
    [-99.29899471463432, 19.26122143592056],
    [-99.2984845580159, 19.261305193379997],
    [-99.29799724507677, 19.261442250059815],
    [-99.29775739498774, 19.26189339586358],
    [-99.29728531026882, 19.26229314631172],
    [-99.29697312500969, 19.262704316351176],
    [-99.29682083921034, 19.26311548728995],
    [-99.296230732862, 19.263305844089473],
    [-99.29556448361399, 19.2636028011284],
    [-99.29509620572526, 19.263808386148128],
    [-99.29477259907617, 19.264067272186935],
    [-99.29423959967772, 19.264596463855753],
    [-99.29419010728759, 19.264901034555123],
    [-99.29398832909806, 19.265281749053543],
    [-99.29406066516754, 19.265571090633387],
    [-99.29401878643779, 19.266035561691865],
    [-99.29379035773877, 19.26635916924033],
    [-99.29352005120938, 19.266888360909206],
    [-99.29289948842063, 19.267489887748184],
    [-99.29274054044356, 19.267643125929567],
    [-99.29258349543193, 19.26830461596529],
    [-99.29225988788346, 19.268537802977278],
    [-99.29166502322221, 19.268766230776976],
    [-99.29122244256166, 19.269047008112977],
    [-99.29092739028681, 19.26920405222529],
    [-99.28995181112714, 19.270084453434833],
    [-99.28963296369028, 19.270293845284755],
    [-99.28932839299091, 19.270350952234708],
    [-99.28857172410574, 19.270217702385082],
    [-99.28818149208217, 19.270165353748155],
    [-99.28789119812024, 19.270165353748155],
    [-99.28751048362187, 19.270170112960386],
    [-99.28681663328098, 19.270416625227142],
    [-99.28618845593246, 19.27069073858678],
    [-99.28565736039883, 19.27140457815881],
    [-99.28542893169981, 19.271827169588278],
    [-99.2854175103098, 19.272186944272107],
    [-99.28528616432499, 19.272900782944816],
    [-99.2852469511858, 19.27311207865955],
    [-99.28494237958711, 19.273279592679103],
    [-99.28471395088809, 19.273568935158266],
    [-99.28405531709916, 19.274596862954922],
    [-99.28375455323004, 19.27475295468514],
    [-99.28342333202113, 19.27501945528371],
    [-99.28332053861192, 19.275103211843827],
    [-99.28322155293228, 19.275430626222487],
    [-99.2831834819321, 19.27573900375205],
    [-99.28331673178172, 19.27600169572173],
    [-99.28376216689043, 19.27623393215032],
    [-99.28392587407978, 19.27670601686924],
    [-99.28397155963972, 19.27696490200867],
    [-99.28348805263147, 19.277273280437612],
    [-99.28305403891272, 19.27775678744581],
    [-99.28245631890394, 19.278780906613576],
    [-99.28231164766436, 19.27902837126237],
    [-99.28206228005013, 19.279228244687772],
    [-99.28150072717676, 19.279499503599254],
    [-99.28132464711473, 19.280189548009275],
    [-99.28114380784041, 19.280622610245302],
    [-99.28079640692857, 19.28076061840784],
    [-99.2804537643297, 19.280765376720808],
    [-99.28044172780346, 19.28076857111273],
    [-99.28022057731778, 19.280827242882992],
    [-99.28001118456848, 19.280960492732618],
    [-99.27963523018167, 19.28116036795666],
    [-99.27940204316974, 19.281469697868317],
    [-99.27919740873341, 19.28167908971824],
    [-99.27901181114612, 19.28171716161779],
    [-99.27864537428457, 19.28162674198063],
    [-99.27850260601042, 19.281493492131005],
    [-99.2783217667361, 19.281407831706133],
    [-99.27823134799826, 19.281417350130653],
    [-99.2781218933107, 19.281488732918717],
    [-99.27800292019856, 19.28155535829319],
    [-99.27792201808666, 19.28171716161779],
    [-99.27789346371236, 19.282002697266705],
    [-99.27788870539939, 19.282602321140246],
    [-99.27683222502714, 19.283211463438363],
    [-99.27331538119984, 19.285191175232626],
    [-99.27366754222328, 19.28566230756951],
    [-99.2750095582445, 19.287518287938667],
    [-99.27588519934244, 19.288712777372837],
    [-99.27616597577912, 19.2891030093964],
    [-99.27512377214435, 19.290730560167276],
    [-99.27473401586212, 19.291347791867167],
    [-99.27318070412616, 19.293144761421672],
    [-99.27276191862762, 19.293738674600206],
    [-99.2724649615887, 19.294210760218448],
    [-99.27248780526799, 19.294667615817843],
    [-99.27235836224861, 19.29499503019656],
    [-99.27232029124843, 19.295360514676076],
    [-99.27209947710912, 19.29550518591566],
    [-99.27206901976939, 19.29558132881533],
    [-99.27184820563014, 19.296129557333245],
    [-99.27149033481106, 19.298010283447866],
    [-99.27165023517017, 19.298360539707176],
    [-99.27148272115062, 19.29917526702502],
    [-99.27055377903366, 19.299700651863645],
    [-99.26973143715605, 19.301177820699934],
    [-99.27037103589453, 19.301413863958715],
    [-99.27047763613399, 19.301581377978266],
    [-99.2712923643511, 19.302091533697364],
    [-99.27149794937083, 19.3023199632957],
    [-99.27209947710912, 19.302418948076024],
    [-99.27221369100897, 19.302472248195727],
    [-99.27139896279186, 19.303089005053607],
    [-99.27080504961333, 19.30372860379208],
    [-99.27062230737357, 19.30398748893151],
    [-99.27037103589453, 19.304155002951063],
    [-99.26941163823648, 19.304611860349098],
    [-99.26916798131725, 19.304703230569658],
    [-99.26842178233937, 19.305129629728697],
    [-99.26868066657948, 19.305342830207508],
    [-99.26975427993602, 19.305738772026757],
    [-99.26998270773572, 19.305754001146283],
    [-99.27017561141531, 19.306106547978857],
    [-99.27042433601429, 19.30656111390431],
    [-99.27053093625369, 19.306644871363744],
    [-99.27074413583318, 19.30671339970371],
    [-99.27124667789184, 19.307170256202426],
    [-99.27128474889201, 19.308320011559317],
    [-99.27081266417309, 19.30875402527812],
    [-99.27114007765243, 19.30905859597749],
    [-99.27032535123396, 19.31183019230957],
    [-99.27049286525352, 19.311586536289667],
    [-99.27054616537322, 19.31194440710874],
    [-99.2699903231948, 19.31272106342641],
    [-99.26944209467689, 19.31363477642384],
    [-99.26897762361841, 19.31374899032369],
    [-99.26872635303874, 19.313855589663774],
    [-99.26847508155976, 19.314015489123562],
    [-99.26820096820006, 19.314068789243265],
    [-99.26801061140054, 19.31410686114276],
    [-99.26778218270152, 19.314213461382167],
    [-99.26762228324174, 19.314205845923084],
    [-99.26766035424191, 19.314091632023235],
    [-99.26750806934189, 19.313787061323865],
    [-99.2672720260831, 19.313771833103658],
    [-99.26711212662332, 19.313695690203986],
    [-99.26659435634446, 19.313505333404464],
    [-99.26587861380693, 19.313436805064555],
    [-99.26545221464795, 19.314160161262464],
    [-99.26523140140802, 19.314441889181865],
    [-99.2649649008095, 19.314807373661438],
    [-99.2646451009906, 19.315035802360455],
    [-99.26450042975102, 19.315332759399382],
    [-99.26349534563366, 19.316071343817498],
    [-99.26317364284932, 19.316309290041772],
    [-99.2624426720916, 19.317177316579944],
    [-99.26216855783264, 19.317365771313348],
    [-99.26175738689386, 19.317708413012895],
    [-99.26167172736831, 19.317839758997707],
    [-99.26159177673907, 19.31827948431078],
    [-99.26135192665004, 19.31882771103011],
    [-99.26103212773046, 19.319558681787782],
    [-99.26082083201572, 19.319895612792322],
    [-99.26057527123174, 19.320158305661323],
    [-99.26042679316191, 19.320483816175226],
    [-99.26037539690702, 19.3205694766001],
    [-99.25961016197937, 19.321334712427074],
    [-99.25921041243055, 19.32160311509176],
    [-99.25903909068143, 19.32183725358641],
    [-99.25871929176185, 19.322065682285483],
    [-99.25857081279275, 19.322128499930386],
    [-99.25844517840221, 19.32227126730521],
    [-99.25808540281906, 19.32239119190001],
    [-99.2579026605793, 19.32252253788488],
    [-99.25774847181447, 19.322613909904078],
    [-99.2572402190608, 19.32327635232184],
    [-99.25667485935725, 19.32410440399508],
    [-99.25652066969309, 19.324361386169073],
    [-99.25632079536837, 19.32474971432788],
    [-99.25633507210586, 19.32495434786489],
    [-99.25625892920618, 19.32522560587705],
    [-99.25590676908212, 19.32573005180052],
    [-99.25581634944496, 19.32573005180052],
    [-99.25540232315865, 19.326301123098403],
    [-99.25517389535895, 19.326558104373078],
    [-99.25469324369823, 19.3267579786978],
    [-99.25409361892531, 19.32695309470961],
    [-99.25393181560077, 19.32694833639664],
    [-99.25356062042624, 19.326862675072448],
    [-99.25334171015174, 19.326867434284736],
    [-99.25310852313982, 19.326981648184585],
    [-99.2529372013907, 19.32701972008408],
    [-99.25234709504235, 19.327091103771465],
    [-99.25135247993296, 19.327086344559177],
    [-99.25117639987093, 19.32704351434677],
    [-99.24996763369933, 19.32702923760928],
    [-99.24934897387601, 19.327210076883603],
    [-99.24866844789051, 19.327576513745157],
    [-99.2486256176781, 19.327690727645006],
    [-99.24831152855415, 19.327804942444175],
    [-99.2480164762793, 19.327871566919328],
    [-99.24723601313144, 19.3279381922938],
    [-99.24661735330818, 19.32803812855684],
    [-99.24634133608373, 19.328090477193825],
    [-99.24588923789798, 19.328123789881033],
    [-99.24553231856163, 19.328114272355833],
    [-99.245399068712, 19.32813330740629],
    [-99.24529913244896, 19.328180896830986],
    [-99.24502311432525, 19.32843787810566],
    [-99.2446376406146, 19.32845691405538],
    [-99.24423313275281, 19.32856161043003],
    [-99.24381910736588, 19.32844739563086],
    [-99.24360495540435, 19.328480709217388],
    [-99.24354308924217, 19.32846643158058],
    [-99.24306719679367, 19.328238003780882],
    [-99.24272455509413, 19.32795246813197],
    [-99.24183463635933, 19.326515274160613],
    [-99.24109700342393, 19.3253207847265],
    [-99.24107320916124, 19.325168498927155],
    [-99.2406734587131, 19.324763991065367],
    [-99.24040220070094, 19.324483213729366],
    [-99.24028798680109, 19.324407071729013],
    [-99.2402499149016, 19.32441183004198],
    [-99.2397692641402, 19.324511768103662],
    [-99.23958706868825, 19.324580809956444],
    [-99.23931716685371, 19.324683088953464],
    [-99.23922674721655, 19.324683088953464],
    [-99.23880796171801, 19.324468937891197],
    [-99.23868423029296, 19.32454032067932],
    [-99.23819406110698, 19.32454032067932],
    [-99.23733745505945, 19.32469736569095],
    [-99.23688059856073, 19.324892481702705],
    [-99.23648084901191, 19.325201811614363],
    [-99.23638091184955, 19.32544451705087],
    [-99.2359859206137, 19.325882336700545],
    [-99.23472480670443, 19.326491478998605],
    [-99.23408806331344, 19.32680651960527],
    [-99.2334598850656, 19.327246244019022],
    [-99.2321292913337, 19.328496888920313],
    [-99.23188372965035, 19.329027985353264],
    [-99.23151824517083, 19.329302098712958],
    [-99.23120986674195, 19.32983319424659],
    [-99.23008485802973, 19.33032431491523],
    [-99.22968510758159, 19.330358579085214],
    [-99.22927964823714, 19.330518479444322],
    [-99.22886847729836, 19.330775460718996],
    [-99.22715336223786, 19.331611127851318],
    [-99.22626820181603, 19.33157305595182],
    [-99.22418379544575, 19.332372555049403],
    [-99.22412668759654, 19.33251532332355],
    [-99.22423138397113, 19.332753268648503],
    [-99.22318442112407, 19.33317205414704],
    [-99.22237540360197, 19.333552767746085],
    [-99.22187095857782, 19.333733607020406],
    [-99.22129988817926, 19.33382878497048],
    [-99.21914885463588, 19.3340001067196],
    [-99.21854923076233, 19.33442840974334],
    [-99.21774973166475, 19.334647320017837],
    [-99.21713107184144, 19.33471394539231],
    [-99.21698830536599, 19.334875747817534],
    [-99.21683601866727, 19.33512321156701],
    [-99.21656951896807, 19.335275498265673],
    [-99.21602700204448, 19.335275498265673],
    [-99.21572623817531, 19.33540874721598],
    [-99.21541785974637, 19.335671440084923],
    [-99.2153379100165, 19.33611687519368],
    [-99.21491531768771, 19.33639098855332],
    [-99.21448130396897, 19.336482359673198],
    [-99.21354474909089, 19.33656231030244],
    [-99.2132477920519, 19.3365166247425],
    [-99.21232265676514, 19.33618540443291],
    [-99.21196859367564, 19.336288196043483],
    [-99.2114660507176, 19.33620824631356],
    [-99.21121478013794, 19.3362539318735],
    [-99.20998126822093, 19.336962059851203],
    [-99.20915892634332, 19.33756739441975],
    [-99.20833658356645, 19.337864350559357],
    [-99.20752566397817, 19.33789861472934]
  ]
];

export { I24MXCoordinates };
